import { observable, action, computed, flow, toJS, set, reaction, runInAction } from 'mobx';
import { get, cloneDeep, isEmpty } from 'lodash';
import { Toast, Modal } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './QuickBuyServ';
import { FileTypeMap } from 'utils/constants';
import Util from 'utils';

const { alert } = Modal;

const getActivityListKey = (activityList = []) => {
  if (!(activityList && activityList.length > 0)) {
    return '';
  }
  if (activityList && activityList.length === 1) {
    return activityList[0].activityId;
  }
  // 把商品活动ID排序，从低到高
  const sortNumber = (a, b) => {
    return a - b;
  };
  const activityListId = activityList
    .map((item) => item.activityId)
    .sort(sortNumber)
    .join(',');

  return activityListId || '';
};

class QuickBuyMod {
  // view层实例
  @observable viewInstance = null;

  // 导航栏商品类型, 1 零售订单、2 复消订单
  @observable orderType = '1';

  @observable distributionRatio = '1';

  @observable discount = '';

  @observable discountList = [];
  // 加了资格购后的门槛金额
  @observable totalPureAmount = 0;
  // 菜单列表
  @observable menuList = [];
  // 子菜单
  @observable menuSubList = [];

  // 每个menu对应的商品列表，格式：{ 类目Id: 对应的productList }, _default为“搜索结果”的id
  @observable menuChildMap = { _default: [] };

  // 所有的商品，格式：{ 商品id: 对应的商品详情（要填充个count和selected进去，记录商品被选数量和是否被选择结算） }
  @observable productMsgMap = {};

  // 当前处于激活状态的菜单id、菜单标题、当前处于激活状态的商品id(后台叫其为itemSerial)
  @observable menuId = '';

  @observable activeKeys = ['', '', ''];

  @observable menuTitle = '';

  @observable detailId = '';

  // 搜索keyword
  @observable keyword = '';

  // 是否为搜索资格购商品
  @observable isQualificationSearch = false;

  // 弹窗显隐：详情-子产品
  @observable showDetail = false;

  // 已选产品列表
  @observable selectedProducts = [];

  @observable tabIndex = 0;

  // 记录已选产品项
  @observable selectedItems = {};

  // 是否参加促销活动
  @observable isJoin = true;

  @observable switchIndexs = [];

  // 是否是去凑单
  @observable isScrape = false;

  // 代客下单会员卡号
  @observable memberCard = '';

  @observable memberId = '';

  // 代客下单的订单类型label
  @observable memberOrderTypeList = [];

  // 店铺配货比例
  @observable storeDistributionList = null;

  // 满赠用到的参数
  // 记录已选赠品项id
  @observable selectedGiftItems = [];

  // 记录已选赠品所有数据
  @observable selectedGiftListItems = [];

  // 当前临时选择的商品列表
  @observable selectedGiftList = [];

  //切换后选择的满赠活动ID
  @observable selectActivityId = '';

  @observable cartIndex = 0;

  @observable giftList = {};

  // 赠品类型，1：实物赠品，2：兑换券类，3：虚拟权益
  @observable giftType = '';

  @observable modalObject = {};

  // 赠送数量
  @observable presentCount = '';

  // 赠送方式，1：全部赠送，2：任选几款 3: 任选几件
  @observable presentWay = '';

  // 保存赠品活动id
  @observable actId = '';

  // 记录所有的活动活动id
  @observable allActivityItems = {
    // '0988': {
    //   activityGiftId: '898989'
    // }
  };

  // 确定每一项的时候，生成gKey
  @observable activityDiscountInfoListGkey = [];

  @observable isQuery = false;

  // 资格购列表
  @observable qualificationList = [];
  // 当前tab是否为资格购
  @observable isQualification = false;

  // 记录已选赠品对应的活动id
  @observable giftListActivity = [];

  // query接口返回数据
  @observable queryReturnData = [];

  @observable defaultActivityList = [];

  @observable bizDefaultGiveawayReqDto = {};

  // 选中的子活动id
  @observable subActId = '';
  // 选中的子活动Code
  @observable subCardCode = '';

  // 子活动的id对象
  @observable idObjectParam = '';

  // 来源 shop  member
  @observable origin = '';

  // 资格购前端隐藏，可以通过跳转链接参与活动
  @observable showFlag = false;

  // 选择的分类 默认全部 -1
  @observable selectedId = -1;

  @observable totaActivityKeys = [];

  @observable selectedAllProduct = true;

  @observable sortType = 1;

  @observable sortOrder = 'DESC';

  // 产品信息
  @observable productInfo = {};

  // 多规格商品
  @observable moreSpecificationsData = [];
  // 选中的多规格商品
  @observable checkItem = {};
  @observable skuCheckLists = {};
  @observable skuArray = {};

  @observable showSkuModal = false;
  @observable swiperIndex = 0;
  // 用来判断
  @observable fromPage = '';

  // 入口名称，仅用于生命周期埋点
  @observable inletTitle = '';

  @observable sourceTag = '';
  // 销售专区属性
  @observable globalSaleMode = '';
  // 当前卡类型
  @observable currentCardType = null;
  // 当前卡名称
  @observable currentCardTypeName = null;
  // 累计值
  @observable hadAccumulateAmount = 0;
  // 用户权益列表
  @observable cardList = [];

  selectItem = '';

  queryList = [];

  // 上一次 可跨越配货比例的商品id，用于对比这次的值，如果不一样就重置配货比例
  oldAcrossDisRatioItemId = '';

  // 记录代客下单，客的配货比例
  oldStoreDistributionList = null;

  @observable isFastPreview = false; // 是否是快速预览

  @observable previewProductList = []; // 快速预览列表

  initialScrollIndex = 0; // 快速预览初始滚动索引

  initialListSize = 20; // 快速预览初始渲染条数

  fastPreviewViewableItems = []; //快速预览商品

  @observable selectCargoScaleDetaile = null; // 选中的资格购信息

  @observable application = []; // 应用位配置列表

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    this[key] = value;
  }

  // 获取默认的赠品
  @action
  getDefaultGiftList() {
    const { defaultActivityList, bizDefaultGiveawayReqDto } = this;
    const { freeItem = [], giftList = [] } = bizDefaultGiveawayReqDto || {};
    if (Array.isArray(toJS(defaultActivityList)) && defaultActivityList.length > 0) {
      let idList = [];
      defaultActivityList.forEach((item) => {
        const { activityId } = item;
        idList = [...idList, activityId];
      });
      this.getdefaultActivityGiftList(idList.join(',')).then((res) => {
        if (res) {
          const freeItemList = [...freeItem, ...res.giftItems];
          const giftListList = [...giftList, ...res.couponRightsList];
          let newObject = {
            freeItem: freeItemList,
            giftList: giftListList
          };
          this.changeState({ bizDefaultGiveawayReqDto: newObject });
        }
      });
    }
  }

  @computed
  get selectMenuList() {
    let returnList =
      this.selectedId == -1
        ? this.menuSubList
        : this.menuList.filter((res) => {
            return res.id == this.selectedId;
          });

    if (this.globalSaleMode == 2 && this.selectedId == -1) {
      const qualiList = toJS(this.menuList).filter((res) => {
        return res.id == 'qualification_id';
      });
      const mergedChildrenList = qualiList.reduce((acc, item) => {
        if (item.childrenList && Array.isArray(item.childrenList)) {
          return acc.concat(item.childrenList);
        }
        return acc;
      }, []);
      returnList = [...returnList, ...mergedChildrenList];
    }
    return returnList;
  }

  // 当前选中的商品是否有可跨越用户配货比例下单的产品
  @computed
  get acrossDisRatioItemId() {
    // 不参与促销，选中的分类不是尊享专区, 则资格够活动不参加
    if (!this.isJoin || this.selectedId !== 'qualification_id') return '';
    const currentItem = this.selectedList.find((itemData) => itemData.acrossDisRatio) || {};
    return currentItem.itemId || currentItem.itemSerial || '';
  }

  // 当存在资格购不可取消 且产品已被勾选时，参与促销活动按钮不可点击
  @computed
  get checkActiveCancelable() {
    let notClickName = '';

    const isNotClick = this.selectedProducts.some(
      (item) =>
        item.activityList &&
        item.activityList.some(
          (actItem) =>
            actItem.notCancelTag == 1 &&
            item.itemList &&
            item.itemList.some((proItem) => {
              if (this.selectedItems[proItem.itemSerial]) {
                notClickName = proItem.itemName;
                return true; // 退出内层循环
              }
              return false;
            })
        )
    );

    return {
      isNotClick: isNotClick,
      notClickName: notClickName
    };
  }

  @action
  changeVideoToImage = () => {
    console.log('changeVideoToImage');
    const list = cloneDeep(toJS(this.previewProductList));
    list.forEach((item, index) => {
      item.inView = this.fastPreviewViewableItems.includes(index);
      if (!item.inView) {
        item.isFirstClick = true;
      }
    });
    this.previewProductList = list;
  };

  @action
  changePaused = (paused, item) => {
    const list = cloneDeep(toJS(this.previewProductList));
    const currentItem = list.find((listItem) => listItem.itemSerial === item.itemSerial) || {};
    if (isEmpty(currentItem)) return;
    list.forEach((item, index) => {
      item.inView = this.fastPreviewViewableItems.includes(index);
      if (!item.inView) {
        item.isFirstClick = true;
      }
    });
    // 将列表里内其他正在播放的视频暂停
    if (!paused) {
      const playIndex = list.findIndex((product) => {
        const mediaRespDtoList = product.mediaRespDtoList || [];
        const hasVideo = mediaRespDtoList.some((media) => media.fileType == FileTypeMap.VIDEO);
        return product.paused === false && hasVideo;
      });
      console.log('playIndex', playIndex);
      if (playIndex > -1) {
        const pausedItem = list[playIndex];
        pausedItem.paused = true;
        pausedItem.isFirstClick = !pausedItem.inView;
      }
    }
    currentItem.paused = paused;
    currentItem.isFirstClick = !currentItem.inView;
    console.log('list', currentItem);
    this.previewProductList = list;
  };

  /**
   * 获取满赠列表
   */
  getdefaultActivityGiftList = flow(function* (theQuestId) {
    try {
      const trueKeys = Object.keys(this.selectedItems).filter(
        (key) => this.selectedItems[key] === true
      );
      const { data, resultCode } = yield Serv.getActivityIdsGiftList({
        saleMode: this.globalSaleMode || '',
        activityIds: theQuestId.split(','),
        itemList:
          this.selectedProducts[this.cartIndex] &&
          this.selectedProducts[this.cartIndex]['itemList'].filter((f) =>
            trueKeys.includes(f.itemSerial || f.id)
          )
      });
      let giftItems = [];
      let couponRightsList = [];
      if (`${resultCode}` == '0') {
        data.forEach((datas, index) => {
          let giftType = get(datas, 'giftType');
          let presentCount = get(datas, 'presentCount');
          let activityId = get(datas, 'activityId');
          let presentWay = get(datas, 'presentWay');
          let newgiftItemList = [];
          if (get(datas, 'giftItemList', []) && get(datas, 'giftItemList', []).length > 0) {
            newgiftItemList = get(datas, 'giftItemList', []).map((item) => {
              item.activityId = activityId;
              return item;
            });
          }
          let newCouponList = [];
          if (get(datas, 'couponList', []) && get(datas, 'couponList', []).length > 0) {
            newCouponList = get(datas, 'couponList', []).map((item) => {
              item.activityId = activityId;
              item.couponName = item.couponName || item.giftCouponName;
              item.couponType = item.couponType !== undefined ? item.couponType : item.deductionType;
              item.couponValue = item.couponValue !== undefined ? item.couponValue : item.giftValue;
              return item;
            });
          }
          let newRightsList = [];
          if (get(datas, 'rightsList', []) && get(datas, 'rightsList', []).length > 0) {
            newRightsList = get(datas, 'rightsList', []).map((item) => {
              item.activityId = activityId;
              return item;
            });
          }
          let newGiftList = [];
          let theGiftList;
          if (+giftType === 5) {
            theGiftList = [...newgiftItemList, ...newCouponList];
            theGiftList.forEach((item) => {
              item.resolvedGiftType = item.couponType !== undefined ? 2 : 1;
            });
          } else {
            theGiftList = [newgiftItemList, newCouponList, newRightsList][datas.giftType - 1] || [];
          }
          if (presentWay == 1) {
            newGiftList = theGiftList.map((item) => {
              const {
                id,
                price: itemPrice,
                couponName,
                giftCount,
                itemName,
                skuSerial,
                giftType: itemGiftType
              } = item || {};
              const effectiveType = +giftType === 5 ? item.resolvedGiftType : +datas.giftType;
              let commonObj = {
                groupKey: 1024,
                itemNum: giftCount,
                activityIdList: [activityId],
                giftType: effectiveType
              };
              if (effectiveType === 2) {
                commonObj = { ...commonObj, itemName: couponName, giftNum: giftCount, giftId: id };
              } else {
                commonObj = { ...commonObj, itemName, skuSerial, itemPrice, itemSerial: id };
              }
              return commonObj;
            });
          } else if (presentWay == 2) {
            let count = presentCount;
            theGiftList.forEach((item) => {
              if (count > 0) {
                const {
                  itemSerial,
                  price: itemPrice,
                  giftCount: itemNum,
                  itemName,
                  skuSerial,
                  giftType: itemGiftType,
                  giftNum,
                  giftId
                } = item || {};
                const effectiveType = +giftType === 5 ? item.resolvedGiftType : +datas.giftType;
                let commonObj = {
                  groupKey: 1024,
                  itemName,
                  itemNum,
                  activityIdList: [activityId]
                };
                if (effectiveType === 2) {
                  commonObj = { ...commonObj, giftType: effectiveType, giftNum, giftId };
                } else {
                  commonObj = { ...commonObj, skuSerial, itemPrice, itemSerial };
                }
                newGiftList.push(commonObj);
                count--;
              }
            });
          }
          if (+giftType === 5) {
            newGiftList.forEach((item) => {
              if (item.giftType === 2) {
                couponRightsList = [...couponRightsList, item];
              } else {
                giftItems = [...giftItems, item];
              }
            });
          } else if (giftType == 1) {
            giftItems = [...giftItems, ...newGiftList];
          } else {
            couponRightsList = [...couponRightsList, ...newGiftList];
          }
        });
        return {
          giftItems,
          couponRightsList
        };
      }
    } catch (e) {}
  });

  /**
   * 获取菜单列表
   *
   */
  getMenuList = flow(function* (isInit = false, params = {}) {
    try {
      this.menuSubList = [];
      let paramsData = {
        ...params,
        saleMode: this.globalSaleMode || ''
      };
      const { data } = yield Serv.getMenuList(paramsData);
      if (Array.isArray(data) && data.length > 0) {
        this.menuList = data || [];
        data &&
          data.map((item) => {
            if (item.childrenList) {
              this.menuSubList = this.menuSubList.concat(item.childrenList);
            }
          });
        if (this.keyword) return;
        let that = this;
        this.getQualificationList(function () {
          that.initActiveMenu();
        });
      }

      if (
        isInit &&
        this.col2List[this.orderType] &&
        toJS(this.col2List[this.orderType]).length == 2
      ) {
        this.distributionRatio = this.col2List[this.orderType]['1']['value'];
      }

      //【前端 | H5】钻卡用户在选择商品的时候能优先识别1:2配货
      // console.log(toJS(this.col2List[this.orderType]),'---->666');
      // systemType 0 三生站点
      if (
        Stores.AppMod.userInfo.cardType == 3 &&
        Stores.AppMod.userInfo.systemType == 0 &&
        toJS(this.col2List[this.orderType]).find((v) => v.value == 2)
      ) {
        // this.orderType = '1';
        // this.distributionRatio = '2';
      }
    } catch (error) {}
  });

  /**
   * 获取资格购列表
   */
  getQualificationList = flow(function* (cb) {
    let pars = {
      saleMode: this.globalSaleMode || ''
    };
    if (this.memberId) {
      pars.placeUserId = this.memberId;
      pars.isPurchasingAgent = 1;
    } else {
      pars.isPurchasingAgent = 0;
      delete pars.placeUserId;
    }
    if (this.showFlag) {
      pars.show = 1;
    }
    let { data, resultCode } = yield Serv.getQualificationList(pars);
    if (resultCode == 0) {
      data = data.map((rest) => {
        const { subActivityId, id } = rest || {};
        if (subActivityId) {
          rest.id = subActivityId;
          rest.mainId = id;
        }
        return rest;
      });
      this.qualificationList = data;

      let dataS = this.qualificationList.map((item) => ({
        type: 'isQualification', // 此字段用来标识是资格购
        name: item.activityName,
        id: item.id,
        mainId: item.mainId,
        parentId: 'qualification_id',
        status: 1,
        extension: 2,
        disabled: false,
        code: item.activityCode
      }));
      if (dataS.length > 0) {
        let it = {
          id: 'qualification_id',
          disabled: false,
          name: '尊享专区',
          childrenList: dataS,
          parentId: get(dataS, 'rootId') || 0,
          status: 1
        };
        this.menuList = [it, ...this.menuList];
      }
      cb && cb();
    }
  });

  findIds = (data, sign) => {
    data.forEach((item) => {
      if (sign) {
        item.mainId && this.queryList.push(item.mainId);
      } else {
        if (item.id) {
          this.queryList.push(item.mainId || item.id);
          // console.log(item.id,'99990000'); // 打印当前项的 id
        }
      }
      if (item.childrenList && item.childrenList.length > 0) {
        // this.findIds(item.childrenList); // 递归调用 findIds 函数，查找子项中的 id
        item.childrenList.forEach((res) => {
          this.queryList.push(res.mainId || res.id);
        });
      }
    });
  };

  // 查找所有的商品 就是包括一级目录下的所有商品
  getAllProduct = flow(function* (obj) {
    const { sortType, sortOrder } = obj || {};
    this.queryList = [];
    this.findIds(this.selectMenuList); // 执行函数查找结果
    const catalogIdList = this.queryList.filter((item) => item != 'qualification_id');
    try {
      const params = {
        catalogIdList,
        sortOrder: sortOrder || this.sortOrder,
        sortType: sortType || this.sortType,
        saleMode: this.globalSaleMode || ''
      };

      const { data } = yield Serv.getProductList(params);
      if (Array.isArray(data)) {
        this.menuId = 'allProduct';
        set(this.menuChildMap, { allProduct: data });
        data.forEach((_val) => {
          if (!this.productMsgMap[_val.itemSerial]) {
            this.productMsgMap[_val.itemSerial] = {
              itemNum: 0,
              selected: false,
              ..._val
            };
          } else {
            this.productMsgMap[_val.itemSerial] = {
              ...this.productMsgMap[_val.itemSerial],
              acrossDisRatio: false
            };
          }
          if (_val.itemType == 6) {
            _val.childList.map((el) => {
              if (!this.productMsgMap[el.itemSerial]) {
                this.productMsgMap[el.itemSerial] = {
                  itemNum: 0,
                  selected: false,
                  ...el
                };
              }
            });
            // let _moreSpecificationsData = _val.childList || []
            // this.moreSpecificationsData = _moreSpecificationsData
            if (!this.skuArray[_val.itemSerial]) {
              this.skuArray[_val.itemSerial] = _val.childList || [];
            }
          }
        });
      }
    } catch (error) {
      console.log(error, 'eeeerererer');
    }
  });

  // 查找所有的商品 就是包括一级目录下的所有商品
  getZiGeAllProduct = flow(function* () {
    this.queryList = [];
    this.menuId = 'allProduct';
    this.findIds(this.selectMenuList, 1); // 执行函数查找结果
    const catalogIdList = this.queryList.filter((item) => item != 'qualification_id');
    let allProductArr = [];
    try {
      const params = catalogIdList || [];
      const { data: dataList } = yield Serv.searchQualificationList(
        params,
        this.globalSaleMode || ''
      );
      dataList.forEach((data) => {
        let productArr = get(data, 'itemReqDto.itemReqDtos');
        const { baseReqDto } = data || {};
        const { subActId, subCardCode, activityCode } = baseReqDto || {};
        if (Array.isArray(productArr)) {
          productArr.forEach((_val) => {
            _val.imgUrl =
              (_val.mediaRespDtoList &&
                get(_val, 'mediaRespDtoList').find((f) => f.fileType == 1) &&
                get(_val, 'mediaRespDtoList').find((f) => f.fileType == 1)['path1']) ||
              '';
            _val.type = 'isQualification';
            _val.price = _val.discountSalePrice;
            _val.itemSerial = _val.itemId;
            _val.skuSerial = _val.skuId;
            _val.bv = _val.itemBv;

            // 某些特定的资格购活动，需要支持跨越用户支持的配货比例下单，即用户只支持1:1,1:2配货比例，资格购支持1:3配货比例，可正常下单，且商品高亮 todo 标志位还需要后端提供，暂时先用这个配置
            _val.acrossDisRatio = data.specialQualificationTag && this.isJoin;
            _val.specialQualificationTag = data.specialQualificationTag;
            _val.activityOrderType = baseReqDto.orderType;
            // 新增子活动信息
            if (activityCode) {
              _val.dgStatus = this.origin === 'shop' ? 1 : 2;
              _val.subActId = subActId;
              _val.subCardCode = subCardCode;
            }
            if (!this.productMsgMap[_val.itemId]) {
              this.productMsgMap[_val.itemId] = {
                vipUpgradeActivity: data.vipUpgradeActivity,
                allowDistributionRatio: data.allowDistributionRatio,
                itemNum: 0,
                selected: false,
                ..._val
              };
            } else {
              this.productMsgMap[_val.itemId] = { ...this.productMsgMap[_val.itemId], ..._val };
            }
          });
        }
        allProductArr = [...allProductArr, ...productArr];
      });
      set(this.menuChildMap, { allProduct: allProductArr });
    } catch (error) {
      console.log(error, 'eeeerererer');
    }
  });

  /**
   * 根据id，获取商品列表
   */
  getProductList = flow(function* (id, p = {}) {
    try {
      if (!id || id === '_default') {
        return;
      }
      let params = {
        catalogId: id,
        sortOrder: p.dir || this.sortOrder,
        sortType: p.sortType || this.sortType,
        saleMode: this.globalSaleMode || ''
      };
      if (this.isDiscountMode && this.discount != 2) {
        params.discount = this.discount;
        params.orderType = this.orderType;
      }

      if (this.memberCard) {
        params.memberCard = this.memberCard;
      }

      const { data } = yield Serv.getProductList(params);
      if (Array.isArray(data)) {
        set(this.menuChildMap, { [id]: data });
        data.forEach((_val) => {
          if (!this.productMsgMap[_val.itemSerial]) {
            this.productMsgMap[_val.itemSerial] = {
              itemNum: 0,
              selected: false,
              ..._val
            };
          } else {
            this.productMsgMap[_val.itemSerial] = {
              ...this.productMsgMap[_val.itemSerial],
              acrossDisRatio: false
            };
          }
          if (_val.itemType == 6) {
            _val.childList.map((el) => {
              if (!this.productMsgMap[el.itemSerial]) {
                this.productMsgMap[el.itemSerial] = {
                  itemNum: 0,
                  selected: false,
                  ...el
                };
              }
            });
            if (!this.skuArray[_val.itemSerial]) {
              this.skuArray[_val.itemSerial] = _val.childList || [];
            }
          }
        });
      }
    } catch (error) {}
  });

  /**
   * 根据id，获取资格购商品列表
   */
  getZiGeProductList = flow(function* (id, idObjectParam) {
    Toast.loading();
    try {
      const params = {
        saleMode: this.globalSaleMode || ''
      };
      if (this.memberCard) {
        params.memberCard = this.memberCard;
      }
      // 选中子活动则搜索子活动的产品 （新增子活动传参）
      const { mainId, id: subActIds } = idObjectParam || {};
      if (mainId) {
        params.subActId = subActIds;
      }
      const { data } = yield Serv.getZiGeProductList(id, params);
      let productArr = get(data, 'itemReqDto.itemReqDtos');
      const { baseReqDto } = data || {};
      const { subActId, subCardCode, activityCode } = baseReqDto || {};
      if (Array.isArray(productArr)) {
        productArr.forEach((_val) => {
          _val.imgUrl =
            (_val.mediaRespDtoList &&
              get(_val, 'mediaRespDtoList').find((f) => f.fileType == 1) &&
              get(_val, 'mediaRespDtoList').find((f) => f.fileType == 1)['path1']) ||
            '';
          _val.type = 'isQualification';
          _val.price = _val.discountSalePrice;
          _val.itemSerial = _val.itemId;
          _val.skuSerial = _val.skuId;
          _val.bv = _val.itemBv;

          // 某些特定的资格购活动，需要支持跨越用户支持的配货比例下单，即用户只支持1:1,1:2配货比例，资格购支持1:3配货比例，可正常下单，且商品高亮
          _val.acrossDisRatio = data.specialQualificationTag && this.isJoin;
          _val.specialQualificationTag = data.specialQualificationTag;
          _val.activityOrderType = baseReqDto.orderType;
          // 新增子活动信息
          if (activityCode) {
            _val.dgStatus = this.origin === 'shop' ? 1 : 2;
            _val.subActId = subActId;
            _val.subCardCode = subCardCode;
          }
          if (!this.productMsgMap[_val.itemId]) {
            this.productMsgMap[_val.itemId] = {
              vipUpgradeActivity: data.vipUpgradeActivity,
              allowDistributionRatio: data.allowDistributionRatio,
              itemNum: _val.isMustBuy ? _val.limitBuyNum : 0,
              selected: false,
              ..._val
            };
          } else {
            const { itemNum } = this.productMsgMap[_val.itemId] || {};
            this.productMsgMap[_val.itemId] = {
              ...this.productMsgMap[_val.itemId],
              ..._val,
              itemNum: itemNum || (_val.isMustBuy ? _val.limitBuyNum : 0),
              selected: _val.selected || _val.isMustBuy
            };
          }
          if (_val.isMustBuy) {
            const { itemNum, limitBuyCount } = this.productMsgMap[_val.itemId] || {};
            this.productMsgMap[_val.itemId].itemNum =
              itemNum > _val.limitBuyNum && itemNum < limitBuyCount ? itemNum : _val.limitBuyNum;
            this.changeCount(_val, parseInt(this.productMsgMap[_val.itemId].itemNum), false);
          }
        });
        set(this.menuChildMap, { [id]: productArr });
      }
      return data;
    } catch (error) {
      console.log('err12', error);
    }
  });

  /**
   * 初始化第一个类目为激活状态
   */
  @action
  initActiveMenu() {
    const data = this.selectMenuList;
    if (data.length == 0) {
      return;
    }

    this.totaActivityKeys = data
      .filter((res) => {
        const { childrenList } = res || {};
        return childrenList && childrenList.length > 0;
      })
      .map((rest) => rest.id);
    let idObjectParam = {};
    if (!data[0].childrenList || data[0].childrenList.length == 0) {
      this.menuId = data[0].mainId || data[0].id;
      idObjectParam = { ...idObjectParam, mainId: data[0].mainId, id: data[0].id };
      this.menuTitle = data[0].name;
      this.activeKeys = [];
    } else if (
      !data[0].childrenList[0].childrenList ||
      data[0].childrenList[0].childrenList.length == 0
    ) {
      this.menuId = data[0].childrenList[0].mainId || data[0].childrenList[0].id;
      idObjectParam = {
        ...idObjectParam,
        mainId: data[0].childrenList[0].mainId,
        id: data[0].childrenList[0].id
      };
      this.menuTitle = data[0].childrenList[0].name;
      this.activeKeys = [data[0].id, this.selectedAllProduct ? '' : data[0].childrenList[0].id];
    } else {
      this.menuId =
        data[0].childrenList[0].childrenList[0].mainId ||
        data[0].childrenList[0].childrenList[0].id;
      idObjectParam = {
        ...idObjectParam,
        mainId: data[0].childrenList[0].childrenList[0].mainId,
        id: data[0].childrenList[0].childrenList[0].id
      };
      this.menuTitle = data[0].childrenList[0].childrenList[0].name;
      this.activeKeys = [
        data[0].id,
        data[0].childrenList[0].id,
        data[0].childrenList[0].childrenList[0].id
      ];
    }
    this.idObjectParam = cloneDeep(idObjectParam);
    if (!this.selectedAllProduct) {
      this.isQualification
        ? this.getZiGeProductList(this.menuId, this.idObjectParam)
        : this.getProductList(this.menuId);
    }
  }

  /**
   * 关键词搜索普通商品
   */
  toSearch = flow(function* (key) {
    try {
      let params = { keyword: key, saleMode: this.globalSaleMode };
      if (this.isDiscountMode) {
        params.discount = this.discount;
        params.orderType = this.orderType;
      }
      if (this.memberCard) {
        params.memberCard = this.memberCard;
      }
      console.log('params12311', params);

      const { data } = yield Serv.getProductList(params);
      if (Array.isArray(data)) {
        set(this.menuChildMap, { _default: data });
        data.forEach((_val) => {
          if (!this.productMsgMap[_val.itemSerial]) {
            this.productMsgMap[_val.itemSerial] = {
              itemNum: 0,
              selected: false,
              ..._val
            };
          }
          if (_val.itemType == 6) {
            _val.childList.map((el) => {
              if (!this.productMsgMap[el.itemSerial]) {
                this.productMsgMap[el.itemSerial] = {
                  itemNum: 0,
                  selected: false,
                  ...el
                };
              }
            });
            if (!this.skuArray[_val.itemSerial]) {
              this.skuArray[_val.itemSerial] = _val.childList || [];
            }
          }
        });
      }
    } catch (error) {}
  });

  /**
   * 关键词搜索资格购商品
   */
  toSearch_2 = flow(function* (key) {
    try {
      const params = {
        isPurchasingAgent: this.memberId ? 1 : 0,
        filterValue: key || '',
        saleMode: this.globalSaleMode
      };
      if (this.memberId) params.placeUserId = this.memberId;
      if (this.isDiscountMode) {
        params.discount = this.discount;
        params.orderType = this.orderType;
      }
      let { data } = yield Serv.searchQualification(params);
      if (Array.isArray(data)) {
        data.forEach((_val) => {
          _val.imgUrl = get(_val, 'mediaRespDtoList[0].path1');
          _val.type = 'isQualification';
          _val.price = _val.discountSalePrice;
          _val.itemSerial = _val.itemId;
          _val.skuSerial = _val.skuId;
          _val.bv = _val.itemBv;
          // 搜索到特定资格购商品时，要支持跨越用户支持的配货比例
          _val.acrossDisRatio = !!_val.specialQualificationTag;
          _val.specialQualificationTag = _val.specialQualificationTag;
          _val.activityOrderType = _val.orderType;
          // // 新增子活动信息
          // if (activityCode) {
          //   _val.bizFastBuyReqDtos = {
          //     dgStatus: this.origin === 'shop',
          //     subActId: subActivityId,
          //     subCardCode: subCardCode,
          //   }
          // }
          if (!this.productMsgMap[_val.itemId]) {
            this.productMsgMap[_val.itemId] = {
              vipUpgradeActivity: data.vipUpgradeActivity,
              allowDistributionRatio: data.allowDistributionRatio,
              itemNum: 0,
              selected: false,
              ..._val
            };
          } else {
            this.productMsgMap[_val.itemId] = { ...this.productMsgMap[_val.itemId], ..._val };
          }
        });
        set(this.menuChildMap, { _default: data });
      }
    } catch (err) {}
  });

  @computed
  get ldFloor() {
    return Stores.AppMod.isLD && this.orderType == '1' && this.distributionRatio > 1;
  }

  // 已选是否有店长物料
  @computed
  get isSelectListHasQualify() {
    let flag = false;
    return flag;
  }

  // 已选是否有vip复购
  @computed
  get isSelectListHasVip() {
    let flag = false;
    for (let key in this.productMsgMap) {
      let item = this.productMsgMap[key];
      if (item.selected && !!item.vipUpgradeActivity && item.itemNum > 0) {
        flag = true;
      }
    }
    return flag;
  }

  /**
   * 活动下单，通用提示处理
   */
  handleActivityCommonTip(title = '提示', resultMsg, callback) {
    alert(title, resultMsg, [
      {
        text: '确认',
        onPress: () => {}
      }
    ]);
  }

  /**
   * 增加商品
   */
  @action
  changeCount(item, value, sign) {
    if (this.getItemDisabled(item, 1)) {
      return;
    }
    if (sign) {
      this.detailId = item.itemSerial;
      this.showDetail = true;
      return;
    }
    // if (item.type != 'isQualification') {
    // }
    let obj = toJS(this.productMsgMap);
    obj = JSON.parse(JSON.stringify(obj));
    if (+item === 0) {
      // 清楚多规格临时数量
      Object.keys(obj).forEach((res) => {
        if (obj[res].itemNumFu) {
          obj[res].itemNumFu = 0;
        }
      });
      this.productMsgMap = obj;
      return;
    }
    if (sign === 0) {
      // 多规格商品临时赋值逻辑
      obj[item.itemSerial].itemNumFu = value;
      if (JSON.stringify(item.selectObject) !== '{}') {
        obj[item.selectObject.itemSerial] = item.selectObject;
        obj[item.selectObject.itemSerial].itemNumFu = value;
      }
    } else {
      if (+value === -1) {
        // 多规格商品确认逻辑
        obj[item.selectObject.itemSerial] = item.selectObject;
        obj[item.selectObject.itemSerial].itemNum = obj[item.itemSerial].itemNumFu;
        obj[item.selectObject.itemSerial].fatherItemSerial = item.itemSerial;
        let newChildList = obj[item.itemSerial].childList.map((res) => {
          if (res.itemSerial == item.selectObject.itemSerial) {
            res.itemNumNew = obj[item.itemSerial].itemNumFu;
          }
          return res;
        });
        // obj[item.itemSerial].itemNumFu = 0;
        // obj[item.selectObject.itemSerial].itemNumFu = 0;
        let allValue = 0;
        newChildList.forEach((res) => {
          allValue += res.itemNumNew || 0;
        });
        obj[item.itemSerial].itemNum = allValue; // 这个总和需要计算
      } else {
        // 普通商品逻辑
        obj[item.itemSerial].itemNum = value;
        obj[item.itemSerial].selected = true;
      }
    }
    // console.log(obj, 'objobjobjobjobj');
    this.productMsgMap = obj;
    this.changeDisRatio();
  }

  /**
   * 减少商品
   */
  @action
  sub(e, itemSerial) {
    let item = this.productMsgMap[itemSerial];
    if (item.type != 'isQualification') {
      if (this.getItemDisabled(item)) {
        return;
      }
    }
    e.stopPropagation();
    let obj = Object.assign({}, this.productMsgMap);
    if (obj[itemSerial].itemNum <= 0) return;
    obj[itemSerial].itemNum--;
    if (obj[itemSerial] <= 0) {
      obj[itemSerial].selected = false;
    }
    this.productMsgMap = obj;
  }

  @action
  changeProductAcrossDisRatio = () => {
    const productList = JSON.parse(JSON.stringify(this.menuChildMap[this.menuId] || []));
    productList.forEach((item) => {
      if (item.specialQualificationTag) {
        item.acrossDisRatio = this.isJoin;
      } else {
        item.acrossDisRatio = false;
      }
    });
    this.menuChildMap[this.menuId] = productList;
  };

  @action
  changeDisRatio() {
    // 变化后支持跨越用户配货比例的商品id和之前的商品id一样，则不重新赋值配货比例
    if (this.acrossDisRatioItemId === this.oldAcrossDisRatioItemId) return;
    const defaultItem = {
      label: '未选择',
      orderMinAmount: 0,
      value: '-1'
    };
    if (this.acrossDisRatioItemId) {
      // 重置为资格购产品支持的配货比例, 且只有零售订单，去掉复消订单
      const itemData = this.productMsgMap[this.acrossDisRatioItemId] || {};
      const allocateCargoScale =
        (itemData.allocateCargoScale && itemData.allocateCargoScale.split(',')) || [];
      const distributionList = [
        // defaultItem,
        ...allocateCargoScale.map((item) => ({
          label: `1:${item}配货`,
          orderMinAmount: 0,
          value: item
        }))
      ];
      const newDirObj = {};
      if (this.memberCard) {
        this.orderTypeList.forEach((item) => {
          newDirObj[item.value] = distributionList;
        });
        this.storeDistributionList = newDirObj;
      }
      this.distributionRatio = Math.max(...allocateCargoScale);
      this.orderType = this.orderTypeList && this.orderTypeList[0].value;
      this.oldAcrossDisRatioItemId = this.acrossDisRatioItemId;
    } else {
      // 重置为用户支持的配货比例
      if (this.memberCard) {
        this.storeDistributionList = this.oldStoreDistributionList;
      }
      this.orderType = this.orderTypeList && this.orderTypeList[0].value;

      let list = [];
      if (
        !this.memberCard &&
        this.distributeRadioList &&
        Object.keys(this.distributeRadioList).length > 0
      ) {
        list = this.distributeRadioList[this.orderType] || [];
      }

      if (
        this.memberCard &&
        this.storeDistributionList &&
        Object.keys(this.storeDistributionList).length > 0
      ) {
        list = this.storeDistributionList[this.orderType] || [];
      }
      if (list.length) {
        const dirValueList =
          list.filter((item) => item.value !== '-1').map((item) => item.value) || [];
        const minDirValue = Math.min(...dirValueList);
        this.distributionRatio = this.isVipRebuy ? 1 : minDirValue || '-1';
      }
      this.oldAcrossDisRatioItemId = '';
    }
  }

  getItemDisabled(item, num) {
    // const { itemProperties, distributionRatio } = item || {};
    // acrossDisRatio - 当前资格购商品是否可跨越用户支持配货比例下单
    const {
      itemProperties,
      propertiesDistributionRatios,
      allowDiscount,
      type,
      distributionRatio: itemDistributionRatio,
      allocateCargoScale,
      acrossDisRatio
    } = item || {};
    let distributionRatio = JSON.parse(propertiesDistributionRatios || '{}')[this.orderType];

    if (this.isDiscountMode) {
      return !(this.discount == 1 || allowDiscount);
    }
    let returnValue =
      !itemProperties ||
      itemProperties.indexOf(`${this.orderType}`) == -1 ||
      !distributionRatio ||
      distributionRatio.indexOf(`${this.distributionRatio}`) == -1;
    if (type === 'isQualification') {
      const activityOrderType =
        item.activityOrderType === 0
          ? ['1', '2']
          : item.activityOrderType
            ? [`${item.activityOrderType}`]
            : ['1']; // 0-不限制 1-零售订单 2-复消订单
      allocateCargoScale &&
        (returnValue =
          allocateCargoScale.indexOf(`${this.distributionRatio}`) == -1 ||
          !activityOrderType.includes(`${this.orderType}`));
      if (acrossDisRatio && activityOrderType.includes(`${this.orderType}`)) {
        returnValue = false;
      }
      if (returnValue && num) {
        this.tipInfo(returnValue, num, '该产品不支持当前比例');
      }
    } else {
      this.tipInfo(returnValue, num, '该产品不支持当前类型或比例');
    }
    return returnValue;
  }

  tipInfo = (returnValue, num, message) => {
    if (returnValue && num) {
      Modal.alert('提示', message, [
        {
          text: '确定',
          onPress: () => {}
        }
      ]);
    }
  };

  /**
   * 选择结算商品
   */
  @action
  selectProduct(itemSerial) {
    let item = this.productMsgMap[itemSerial];
    if (this.getItemDisabled(item)) {
      return;
    }
    let obj = Object.assign({}, this.productMsgMap);
    obj[itemSerial].selected = !obj[itemSerial].selected;
    this.productMsgMap = obj;
  }

  @action
  changeSelectedGift(
    id,
    isSelected,
    activityId,
    thisCartIndex,
    count,
    presentWay,
    sign,
    isSku = false
  ) {
    // 全选无法取消
    if (+presentWay === 1 && sign && !isSku) return;
    let value = JSON.parse(JSON.stringify(this.selectedGiftItems));
    value = Array.from(value);
    let object = value[+thisCartIndex] || {};
    object[activityId] = object[activityId] || {};
    id && (object[activityId][id] = !isSelected);
    // object[activityId].presentCount = count;
    if (count == 1 && presentWay != 3) {
      console.log(object[activityId]);
      for (var k in object[activityId]) {
        if (k != id) {
          object[activityId][k] = false;
        }
      }
    }
    const returnValue = Object.values(object[activityId]).findIndex((item) => item);
    if (returnValue === -1 && presentWay != 3) {
      Toast.info('赠品至少选择一个哦');
      return false;
    }
    // 赠品全选逻辑
    if (sign && presentWay == 1 && returnValue != count - 1 && !isSku) {
      return false;
    }
    value[+thisCartIndex] = object;
    this.selectedGiftItems = value;
    return true;
  }

  /**
   * 获取满赠列表
   */
  getActivityGiftList = flow(function* ({ activityIds }, thisCartIndex) {
    const oldGiftList = cloneDeep(toJS(this.giftListActivity)) || [];
    let __selectedGiftItems = cloneDeep(toJS(this.selectedGiftListItems)) || [];
    console.log('oldGiftList===', oldGiftList, __selectedGiftItems);
    try {
      const trueKeys = Object.keys(this.selectedItems).filter(
        (key) => this.selectedItems[key] === true
      );

      console.log(this.cartIndex, '购物车的索引', trueKeys);
      let { data, resultCode } = yield Serv.getActivityIdsGiftList({
        saleMode: this.globalSaleMode || '',
        activityIds: activityIds.split(','),
        itemList:
          this.selectedProducts[this.cartIndex] &&
          this.selectedProducts[this.cartIndex].itemList.filter((f) =>
            trueKeys.includes(f.itemSerial || f.id)
          )
      });
      let AllGiftList = {};
      let modalObject = {};
      let modalObjectList = toJS(this.modalObject) || [];
      let AllGiftListActivity = toJS(this.giftListActivity) || [];
      if (`${resultCode}` == '0') {
        data.forEach((datas, index) => {
          let giftItemList = get(datas, 'giftItemList') || [];
          let couponList = get(datas, 'couponList') || [];
          let rightsList = get(datas, 'rightsList') || [];
          let giftType = get(datas, 'giftType');
          let activityId = get(datas, 'activityId');
          let presentCount = get(datas, 'presentCount');
          let presentWay = get(datas, 'presentWay');
          let random = get(datas, 'random');
          let shared = get(datas, 'shared');
          let blessingBagAlias = get(datas, 'blessingBagAlias');
          let blessingBagImg = get(datas, 'blessingBagImg');
          let theGiftList;
          if (+giftType === 5) {
            theGiftList = [...giftItemList, ...couponList];
            theGiftList.forEach((item) => {
              item.resolvedGiftType = item.couponType !== undefined ? 2 : 1;
            });
          } else {
            theGiftList = [giftItemList, couponList, rightsList][giftType - 1];
          }
          let hisGift = [];
          // const obj = oldGiftList.reduce((a, b) => ({...a, ...b}), {});
          // const obj = new Map();
          oldGiftList.map((oldGift) => {
            for (const k in oldGift) {
              if (k == activityId) {
                hisGift = oldGift[k];
              }
            }
          });
          let newTheGiftList = theGiftList.map((itemVal) => {
            itemVal.presentWay = presentWay;
            itemVal.presentCount = presentCount;
            itemVal.random = random;
            itemVal.giftMulti = datas.giftMulti;
            itemVal.blessingBagAlias = blessingBagAlias;
            itemVal.blessingBagImg = blessingBagImg;
            if (itemVal.subGiftItemSelectRespDtoList) {
              // 如果多赠品列表选择时  回显原选择的赠品列表里的sku子产品
              if (hisGift.length) {
                hisGift.forEach((el) => {
                  if (el.itemSerial == itemVal.itemSerial) {
                    itemVal.subGiftItemSelectRespDtoList = el.subGiftItemSelectRespDtoList;
                  }
                });
              }
            }
            return itemVal;
          });
          AllGiftList[activityId] = newTheGiftList;
          let thisModalObject = {
            giftType,
            presentCount,
            presentWay,
            random,
            shared,
            blessingBagAlias,
            blessingBagImg
          };
          modalObject[activityId] = thisModalObject;
          if (presentWay == 1) {
            theGiftList.forEach((item) => {
              const effectiveType = +giftType === 5 ? item.resolvedGiftType : +giftType;
              const hasInventory = effectiveType === 2 || item.availableStock > 0;
              if (!item.subGiftItemSelectRespDtoList && hasInventory) {
                this.changeSelectedGift(
                  effectiveType === 1 ? item.itemSerial : item.id,
                  false,
                  activityId,
                  thisCartIndex,
                  theGiftList.length,
                  presentWay
                );
              }
            });
          }
          if (presentWay == 2) {
            // 限制数量的自上而下选中可选赠品
            let count = 0;
            this.selectedGiftItems[thisCartIndex] &&
              this.selectedGiftItems[thisCartIndex][activityId] &&
              Object.values(this.selectedGiftItems[thisCartIndex][activityId]).forEach((res) => {
                res && count++;
              });
            if (count === 0) {
              theGiftList.forEach((item, index) => {
                const effectiveType = +giftType === 5 ? item.resolvedGiftType : +giftType;
                const hasInventory = effectiveType === 2 || item.availableStock > 0;
                if (!item.subGiftItemSelectRespDtoList && hasInventory) {
                  if (index < (random ? theGiftList.length : presentCount)) {
                    this.changeSelectedGift(
                      effectiveType === 1 ? item.itemSerial : item.id,
                      false,
                      activityId,
                      thisCartIndex,
                      presentCount,
                      presentWay
                    );
                  }
                }
              });
            }
          } else if (presentWay == 3) {
            // 经产品更改需求  presentWay==3默认不选
            // newTheGiftList.forEach((item, index) => {
            //   if (!item.subGiftItemSelectRespDtoList) {
            //     if ((index < (random ? theGiftList.length : presentCount))) {
            //       item.itemSelectNum = 1
            //       this.changeSelectedGift(
            //         giftType == 1 ? item.itemSerial : item.id,
            //         false,
            //         activityId,
            //         thisCartIndex,
            //         presentCount,
            //         presentWay
            //       );
            //     }
            //   }
            // });
            // AllGiftList[activityId] = newTheGiftList;
          }
        });
        modalObjectList[thisCartIndex] = modalObject;
        this.modalObject = modalObjectList;
        AllGiftListActivity[thisCartIndex] = toJS(AllGiftList);
        this.giftList = AllGiftList;
        this.giftListActivity = AllGiftListActivity;
        if (thisCartIndex) {
          this.cartIndex = thisCartIndex;
        }
        this.handleSelectedGiftList(thisCartIndex, AllGiftList);
      }
    } catch (error) {
      console.log(error);
    }
  });

  /**
   * 获取加价购信息
   */
  getIncPriceShopMsg = flow(function* (gKey) {
    const list = [];
    const cartItem = this.selectedProducts.find((group) => group.gKey == gKey);
    const { activityList, itemList } = cartItem;
    // 如果活动不包含加价购物，则返回
    const hasIncPriceAct = activityList.some((activity) => activity.activityType == 4);
    if (!hasIncPriceAct) return;
    if (activityList && activityList.length > 0 && this.isJoin) {
      const activityInfoReqDtoList = [];
      for (const item of itemList) {
        if (this.selectedItems[item.itemSerial]) {
          activityInfoReqDtoList.push(item);
        }
      }
      if (activityInfoReqDtoList.length > 0) {
        list.push({
          activityInfoReqDtoList: activityList,
          itemfoReqDtoList: activityInfoReqDtoList,
          distributionRatio: this.distributionRatio,
          orderType: this.orderType
        });
      }
    }
    if (list.length == 0) return;

    const params = {
      calculateDiscountReqDtoList: list,
      distributionRatio: this.distributionRatio,
      orderType: this.orderType,
      dgCardno: this.memberCard || ''
    };
    try {
      const { data } = yield Serv.getIncPriceShopMsg(params);
      let list = [...this.selectedProducts];
      let cartItemIndex = -1;
      this.selectedProducts.some((group, index) => {
        if (group.gKey == gKey) {
          cartItemIndex = index;
          return true;
        }
      });
      // 是否是盲盒活动
      const isRand = get(data, 'random', 0);
      list[cartItemIndex].incPriceShop = {
        items: get(data, 'itemRespDtoList', []).map((item, i) => {
          // 盲盒活动默认取第一个选中
          if (isRand) {
            return {
              ...item,
              itemNum: i === 0 ? get(data, 'increment', 0) : 0,
              isSelected: i == 0
            };
          } else {
            // 只有一个商品，默认选中
            // 如果那个商品是多规格商品，不选中
            const isUnion = get(data, 'itemRespDtoList', []).length === 1;
            const canSelect = get(data, 'increment', 0) > 0;
            const isNormalProduct = (item.subGiftItemSelectRespDtoList || []).length == 0;

            const defaultSelect = isUnion && isNormalProduct && canSelect;
            return {
              ...item,
              itemNum: defaultSelect ? 1 : 0,
              isSelected: defaultSelect
            };
          }
        }),
        rand: isRand,
        shared: get(data, 'shared', 1),
        blessingBagAlias: get(data, 'blessingBagAlias', ''),
        blessingBagImg: get(data, 'blessingBagImg', ''),
        maxIncPriceNum: get(data, 'increment', 0),
        incPriceMoney: get(data, 'priceIncrease', 0),
        incPriceType: get(data, 'priceIncreaseType', 0)
      };
      this.selectedProducts = list;
      this.viewInstance.forceUpdate();
    } catch (error) {}
  });

  // 正向选择赠品 (主动从赠品弹框选择赠品)
  @action
  handleSelectedGiftList(thisCartIndex, AllGiftList) {
    let AllSelectedGiftList = {};
    let selectedGiftItems = toJS(this.selectedGiftItems);
    let selectedValue = [...this.selectedGiftListItems];
    let giftKeys = Object.keys(AllGiftList || toJS(this.giftList));
    const itemValue = selectedGiftItems[thisCartIndex];
    console.log(itemValue, 'itemValueitemValue');
    giftKeys.forEach((items, index) => {
      // 选中的满赠礼品循环[[满赠1],[满赠2]]
      let selectedGiftList = [];
      (AllGiftList || toJS(this.giftList))[items] &&
        (AllGiftList || toJS(this.giftList))[items].forEach((item) => {
          const effectiveType = item.resolvedGiftType !== undefined ? item.resolvedGiftType : item.giftType;
          let id = effectiveType == 1 ? item.itemSerial : item.id;
          itemValue &&
            itemValue[items] &&
            Object.keys(itemValue[items]).forEach((it) => {
              // 循环已选择的赠品
              if (itemValue[items][it] && it == id) {
                // 选中状态的赠品和满赠的赠品相同;
                if (
                  !toJS(item.subGiftItemSelectRespDtoList) ||
                  (item.subGiftItemSelectRespDtoList &&
                    item.subGiftItemSelectRespDtoList.some((el) => el.isSelected)) ||
                  item.presentWay == 3
                ) {
                  selectedGiftList.push(item); // 存储其中 一个满赠活动的满赠的产品
                } else {
                  itemValue[items][it] = false;
                }
              }
            });
        });
      AllSelectedGiftList[items] = selectedGiftList;
      this.selectedGiftItems = selectedGiftItems;
    });
    // 将该组下的多个满赠赋值到该分组内容下
    if (+thisCartIndex >= 0) {
      selectedValue[thisCartIndex] = AllSelectedGiftList;
    } else {
      selectedValue[this.cartIndex] = AllSelectedGiftList;
    }
    console.log(selectedValue, 'selectedValueselectedValueselectedValue');
    // selectedValue.forEach((selecItem) => {
    //   selecItem && Object.values(selecItem).forEach(__item => {
    //     __item && __item.length && __item.forEach((__sku, sku_idx) => {
    //       // 删除有sku且未选中sku的赠品
    //       if (toJS(__sku.subGiftItemSelectRespDtoList) &&
    //       !__sku.subGiftItemSelectRespDtoList.some(el => el.isSelected)) {
    //         __item.splice(sku_idx, 1);
    //       }
    //     });
    //   });
    // });
    this.selectedGiftListItems = selectedValue;
  }

  // 反向选择赠品
  @action
  handleSelectedGiftListFan = (index, activityId) => {
    // cartIndex 记录是哪个分组的
    this.cartIndex = index;
    if (!Array.isArray(activityId) && activityId.length > 0) {
      activityId = [activityId];
    }
    if (Array.isArray(activityId) && activityId.length > 0) {
      activityId.length === 1
        ? this.getActivityGiftList({ activityIds: activityId[0] }, index)
        : this.getActivityGiftList({ activityIds: activityId.join(',') }, index);
    }
    // let value = {};
    // let valueList = JSON.parse(JSON.stringify(toJS(this.selectedGiftListItems)));
    // if (
    //   valueList[index] &&
    //   valueList[index].length > 0
    // ) {
    //   // 处理选择的赠品
    //   valueList[index][activityId] &&
    //   valueList[index][activityId].forEach(item => {
    //     value[index][activityId][item.itemSerial] = true;
    //   });
    // }
    // this.selectedGiftItems = value;
  };

  /**
   * 产品列表
   */
  @computed
  get productList() {
    toJS(this.menuChildMap);
    console.log(toJS(this.menuChildMap), 'this.menuChildMapthis.menuChildMap', this.menuId);
    return this.menuChildMap[this.menuId] || [];
  }

  @action
  changeOrderType(orderType) {
    this.orderType = orderType;
    const { hasDisable } = this.getSelectedData();
    if (hasDisable) {
      Toast.info('因订单类型变化，部分产品不可以下单', 3, null, false);
    }
  }

  getSelectedData() {
    console.log('toJS(this.productMsgMap)--------', toJS(this.productMsgMap));
    let selectedList = Object.values(toJS(this.productMsgMap)).filter((_val) => {
      // return _val.itemNum > 0 && !_val.itemNumFu && +_val.itemType !== 5;
      return _val.itemNum > 0 && +_val.itemType !== 5;
    });
    let hasDisable = false;
    selectedList = selectedList.map((_val) => {
      if (_val.type !== 'isQualification') {
        if (this.getItemDisabled(_val)) {
          _val.selected = false;
          hasDisable = true;
        }
        return _val;
      }
      if (_val.type == 'isQualification') {
        _val.selected = true;
        return _val;
      }
    });

    // let _skuCheckLists = this.skuCheckLists
    // if(Object.keys(toJS(_skuCheckLists)).length){
    //   for(let item in toJS(_skuCheckLists)){
    //     selectedList = [...selectedList,...(toJS(_skuCheckLists[item]))]
    //   }
    // }

    return { hasDisable, selectedList };
  }

  /**
   * 所选的商品
   */
  @computed get selectedList() {
    const { selectedList } = this.getSelectedData();

    return selectedList;
  }

  /**
   * 合计金额、bv
   */
  @computed
  get totals() {
    let totalNum = 0;
    let totalAmount = 0;
    let totalBv = 0;
    let totalSelectedCount = 0; // 已选产品列表的选中产品数量
    this.selectedList.forEach((item) => {
      if (item.selected) {
        totalNum += parseInt(item.itemNum);
      }
    });

    for (const cartItem of this.selectedProducts) {
      const { activityList = [], itemList } = cartItem;
      // 分组有产品选择
      let flag = false;
      for (const item of itemList) {
        const { itemSerial, price, itemNum, bv, discountBv, discount, promotionBv } = item;
        if (this.selectedItems[itemSerial]) {
          flag = true;
          totalAmount += price * itemNum;
          // totalBv = totalBv + bv * itemNum - (discountBv || 0);
          totalBv = totalBv + (promotionBv || bv) * itemNum;
          // this.ldFloor ? (totalBv = totalBv + promotionBv * itemNum) : (totalBv = totalBv + bv * itemNum - (discountBv || 0));
          totalSelectedCount += Number(itemNum);
          if (this.isDiscountMode) {
            totalAmount -= discount || 0;
          }
        }
      }
      if (!this.isDiscountMode && flag && activityList && activityList.length > 0) {
        for (const item of activityList) {
          const {
            achieve, // 是否满足
            reduceAmount // 优惠金额，如 已减100.00 返回 100.00
          } = item;
          if (achieve) {
            totalAmount -= reduceAmount || 0;
          }
        }
      }
    }
    this.incPriceTotal.map((item, index) => {
      totalSelectedCount += item.count;
      totalAmount += item.money;
    });

    // this.selectedProducts.forEach((item, index) => {
    //   this.selectedGiftListItems[index] &&
    //   Object.values(this.selectedGiftListItems[index]).forEach((item, index) => {
    //         if (item.giftCount && item.giftType === 1) {
    //           totalSelectedCount += item.giftCount;
    //         }
    //     });
    // });

    return {
      totalNum,
      totalAmount,
      totalBv: parseInt(totalBv),
      totalSelectedCount
    };
  }

  // 是否折扣模式
  @computed
  get isDiscountMode() {
    return false;
    // return Object.keys(this.discountList).length > 0
  }
  // 是否显示资格购-干细胞配货比例
  @computed
  get isShopMasterMode() {
    return false;
    return Object.keys(this.masterDistributionList).length > 0;
  }

  // 资格购-干细胞配货比例
  @computed
  get masterDistributionList() {
    // let obj = {}
    // let arr = []
    // for (const cartItem of this.selectedProducts) {
    //   if (cartItem.activityList) {
    //     for (const item of cartItem.activityList) {
    //       if (item.allowDistributionRatio) {
    //         arr = [...arr, ...item.allocateCargoScale.split(',')]
    //       }
    //     }
    //   }
    // }
    // if (arr.length > 0) {
    //   let newArr = new Set(arr)
    //   newArr = Array.from(newArr).map(item => {
    //     return {
    //       label: `1:${item} 配货`,
    //       value: item
    //     }
    //   })
    //   if (newArr.length > 1) {
    //     obj[1] = [{label: '未选择', value: "-1"}, ...newArr]
    //     obj[2] = [{label: '未选择', value: "-1"}, ...newArr]
    //   } else {
    //     obj[1] = newArr
    //     obj[2] = newArr
    //   }
    //   return obj
    // } else {
    return {};
    // }
  }

  @computed
  get orderTypeList() {
    const userInfo = Stores.AppMod.userInfo || {};
    const orderLabelList = this.memberCard
      ? this.memberOrderTypeList
      : (userInfo && userInfo.orderLabelList) || [];

    const list = orderLabelList.map((item) => ({ label: item.label, value: item.value }));

    if (this.isVipRebuy) {
      list.push({ value: '10', label: 'VIP复购订单' });
    }

    if (this.selectCargoScaleDetaile && this.selectCargoScaleDetaile.id) {
      const { baseReqDto } = this.selectCargoScaleDetaile || {};
      const { orderType } = baseReqDto || {};
      const activityOrderType = orderType === 0 ? [1, 2] : orderType ? [orderType] : [1]; // 0-不限制 1-零售订单 2-复消订单
      const supplyOrder = activityOrderType.map((item) => ({
        label: item === 1 ? '零售订单' : '复消订单',
        value: item
      }));
      if (!supplyOrder.length) return [];
      return supplyOrder;
    }

    if (this.acrossDisRatioItemId) {
      const itemData = this.productMsgMap[this.acrossDisRatioItemId] || {};
      const activityOrderType =
        itemData.activityOrderType === 0
          ? [1, 2]
          : itemData.activityOrderType
            ? [itemData.activityOrderType]
            : [1]; // 0-不限制 1-零售订单 2-复消订单
      // 用户支持的订单类型和资格购活动支持的订单类型的交集
      const supplyOrder =
        orderLabelList.filter((item) => activityOrderType.includes(item.value)) || [];
      if (!supplyOrder.length) return [];
      return supplyOrder;
    }

    return list;
  }

  @computed
  get distributeRadioList() {
    if (this.selectCargoScaleDetaile && this.selectCargoScaleDetaile.id) {
      const { baseReqDto } = this.selectCargoScaleDetaile || {};
      const { allocateCargoScale } = baseReqDto || {};
      const defaultItem = {
        label: '未选择',
        orderMinAmount: 0,
        value: '-1'
      };
      const distributionList = [
        defaultItem,
        ...(allocateCargoScale || []).map((item) => ({
          label: `1:${item}配货`,
          orderMinAmount: 0,
          value: item
        }))
      ];
      const newDirObj = {};
      this.orderTypeList.forEach((item) => {
        newDirObj[item.value] = distributionList;
      });
      return newDirObj;
    }
    if (this.acrossDisRatioItemId) {
      const defaultItem = {
        label: '未选择',
        orderMinAmount: 0,
        value: '-1'
      };
      // 重置为资格购产品支持的配货比例, 且只有零售订单，去掉复消订单
      const itemData = this.productMsgMap[this.acrossDisRatioItemId] || {};
      const allocateCargoScale =
        (itemData.allocateCargoScale && itemData.allocateCargoScale.split(',')) || [];
      const distributionList = [
        // defaultItem,
        ...allocateCargoScale.map((item) => ({
          label: `1:${item}配货`,
          orderMinAmount: 0,
          value: item
        }))
      ];
      const newDirObj = {};
      this.orderTypeList.forEach((item) => {
        newDirObj[item.value] = distributionList;
      });
      return newDirObj;
    }
    return Stores.AppMod.userInfo.distributionRatioList || [];
  }
  // 顶部分类列第二栏
  @computed
  get col2List() {
    let col2 = {};
    if (this.isShopMasterMode) {
      col2 = this.masterDistributionList;
    } else {
      if (this.isDiscountMode) {
        col2 = this.discountList;
      } else {
        if (this.memberCard) {
          col2 = this.storeDistributionList;
          if (this.selectCargoScaleDetaile && this.selectCargoScaleDetaile.id) {
            const { baseReqDto } = this.selectCargoScaleDetaile || {};
            const { allocateCargoScale } = baseReqDto || {};
            const defaultItem = {
              label: '未选择',
              orderMinAmount: 0,
              value: '-1'
            };
            const distributionList = [
              defaultItem,
              ...(allocateCargoScale || []).map((item) => ({
                label: `1:${item}配货`,
                orderMinAmount: 0,
                value: item
              }))
            ];
            const newDirObj = {};
            this.orderTypeList.forEach((item) => {
              newDirObj[item.value] = distributionList;
            });
            col2 = newDirObj;
          }
        } else {
          col2 = this.distributeRadioList;
        }
      }
    }
    return col2;
  }

  @computed
  get cartTypeList() {
    // 设置children
    const handleTypeList = (objList) => {
      let arr = [];
      if (objList && Object.keys(objList).length > 0) {
        this.orderTypeList.forEach((item) => {
          let obj = {};
          obj.value = item.value;
          obj.label = item.label;
          // obj.children = this.distributeRadioList[item.value];
          obj.children = objList[item.value];
          arr.push(obj);
        });
      }
      return arr;
    };
    let pickerList = handleTypeList(toJS(this.col2List));

    return pickerList;
    // return [this.orderTypeList, this.distributeRadioList['1']];
  }

  @computed get hideTitle() {
    const { cartTypeList } = this;
    console.log(cartTypeList, 'cartTypeListcartTypeList');
    const newCartTypeList = cartTypeList.filter((item) => {
      const { children } = item || {};
      if (Array.isArray(children) && children.length > 0) {
        return item;
      }
    });

    if (Array.isArray(newCartTypeList) && newCartTypeList.length === 1) {
      const { children } = newCartTypeList[0];
      const filterValue = children.filter((res) => {
        const { value } = res || {};
        if (+value !== -1) {
          return res;
        }
      });
      if (Array.isArray(filterValue) && filterValue.length === 1) {
        return true;
      }
    }
    return false;
  }

  /**
   * 处理配送比例，根据接口返回设置
   */
  @action
  handleDistributionRatio() {
    if (!this.distributionRatio) {
      if (this.distributeRadioList && Object.keys(this.distributeRadioList).length > 0) {
        this.distributionRatio = this.isVipRebuy
          ? 1
          : this.distributeRadioList[this.orderType][0].value;
      }
    }
  }

  /**
   * 是否vip复购
   */
  @computed
  get isVipRebuy() {
    if (!this.selectedProducts || this.selectedProducts.length == 0) {
      return false;
    }
    let flag = false;
    for (const productItem of this.selectedProducts) {
      if (productItem.activityList) {
        for (const item of productItem.activityList) {
          if (item.vipUpgradeActivity === 1) {
            flag = true;
            break;
          }
        }
      }
    }

    return flag;
  }

  @computed
  get cartTypeText() {
    let txt = '';
    const handleCartTypeText = (listObj) => {
      let text = '';
      if (listObj && Object.keys(listObj).length > 0) {
        for (let i = 0; i < this.orderTypeList.length; i++) {
          if (`${this.orderType}` == this.orderTypeList[i].value) {
            text = this.orderTypeList[i].label;
            break;
          }
        }
        let checkItem =
          this.isDiscountMode && !this.isShopMasterMode
            ? `${this.discount}`
            : `${this.distributionRatio}`;
        if (listObj[this.orderType]) {
          for (let i = 0; i < listObj[this.orderType].length; i++) {
            if (checkItem == listObj[this.orderType][i].value) {
              text = `${text}，${listObj[this.orderType][i].label}`;
              break;
            }
          }
        }
      }

      return text;
    };
    txt = handleCartTypeText(toJS(this.col2List));
    return this.isVipRebuy ? 'VIP复购订单' : txt;
  }
  // 店长最大折扣
  @computed
  get maxMasterDR() {
    let arr = [];
    this.selectedList.map((item) => {
      if (item['allocateCargoScale']) {
        arr = [...arr, item['allocateCargoScale'].split(',')];
      }
    });
    return Math.max(...arr);
  }

  /**
   * 不参与促销活动，计算出普通商品组数据
   */
  @computed
  get selectedProductsForSection() {
    let itemList = [];
    return this.selectedProducts.map((section) => {
      return { ...section, activityList: [] };
    });
  }

  /**
   * 获取已选产品列表
   */
  getSelectedProducts = flow(function* () {
    if (
      !this.selectedList ||
      this.selectedList.length == 0 ||
      !this.orderType ||
      (!this.distributionRatio && !this.discount)
    ) {
      this.selectedProducts = [];
      return;
    }

    Toast.loading('加载中...');
    // vip复购订单，按照零售订单请求
    const orderType = this.orderType == '10' ? '1' : this.orderType;
    console.log('========', this.selectedList);
    let params = {
      saleMode: this.globalSaleMode || ''
    };
    if (this.selectCargoScaleDetaile) {
      params.qualificationId = this.selectCargoScaleDetaile.id;
    }
    try {
      const { data, resultCode, resultMsg } = yield Serv.getSelectedProducts(
        this.selectedList,
        orderType,
        this.distributionRatio,
        this.memberCard,
        this.discount,
        this.showFlag,
        params
      );
      if (+resultCode === 10001) {
        Toast.fail(resultMsg, 2);
      } else {
        Toast.hide();
      }
      let selectedProducts = data || [];
      this.setSubActivity(selectedProducts);
      this.selectedProducts = selectedProducts;
      this.allActivityItems = {};
      this.selectedProducts = this.addActivityProductsKeys(toJS(this.selectedProducts));

      // 对已选的分组，进行请求加价购
      this.selectedProducts.forEach((products, index) => {
        products.itemList.forEach((_item, _index) => {
          if (this.selectedItems[_item.id]) {
            this.getIncPriceShopMsg(this.selectedProducts[index].gKey);
          }
          const { isMustBuy, limitBuyNum } = this.findProductInValidActivity(
            this.selectedProducts[index],
            _item.itemSerial
          );
          if (isMustBuy && _item.itemNum < limitBuyNum && this.isJoin) {
            _item.itemNum = limitBuyNum;
            this.changeItemNum(_item.itemNum, index, _index, _item.itemSerial, 0, false, true);
          }
        });
      });
      // vip复购默认1:1
      if (this.isVipRebuy && this.orderType != '10') {
        this.orderType = '10';
        this.distributionRatio = 1;
      }

      if (!this.isVipRebuy && this.orderType == '10') {
        this.orderType = '1';
        this.distributionRatio = '1';
        this.getSelectedProducts();
      }

      this.getDiscountBatch();
    } catch (error) {
      const { resultCode, resultMsg } = error || {};
      if (+resultCode === 10001) {
        Toast.fail(resultMsg, 2);
      } else {
        Toast.hide();
      }
    }
  });

  // 设置子活动信息
  @action
  setSubActivity(data) {
    let activityLists = [];
    data.forEach((items) => {
      const { activityList = [] } = items || {};
      if (Array.isArray(activityList) && activityList.length > 0) {
        activityLists = [...activityLists, ...activityList];
      }
    });
    activityLists.forEach((items) => {
      const { subActId, subCardCode } = items || {};
      if (subActId) {
        this.subActId = subActId;
        this.subCardCode = subCardCode;
      } else {
        this.subActId = '';
        this.subCardCode = '';
      }
    });
  }

  /**
   * 获取产品项是否可选
   * retailOrderTypeStatus 是否支持零售订单类型(1：支持 0：不支持)
   * monthlyOrderTypeStatus 是否支持复消订单(1：支持 0：不支持)
   */
  getItemCanSelect(item) {
    const {
      retailOrderTypeStatus,
      monthlyOrderTypeStatus,
      limitNum,
      itemStatus,
      allowDiscount,
      distributionRatio
    } = item;

    if (this.onManaging) {
      return true;
    }
    if (
      this.isDiscountMode &&
      !(allowDiscount || this.discount == 1) &&
      !this.isSelectListHasQualify
    ) {
      return false;
    }
    return (
      ((this.orderType == '1' && retailOrderTypeStatus == 1) ||
        (this.orderType == '2' && monthlyOrderTypeStatus == 1) ||
        this.orderType == '10') &&
      `${itemStatus}` == '1' &&
      // (distributionRatio
      //   ? distributionRatio.indexOf(this.distributionRatio) >= 0
      //   : false) &&
      (limitNum == null ? true : limitNum > 0)
    );
  }

  @action
  onCartTypePick(value) {
    this.orderType = value[0];
    if (this.isDiscountMode && !this.isShopMasterMode) {
      this.discount = value[1];
    } else {
      this.distributionRatio = value[1];
    }
    // 清除已经选择的赠品
    this.selectedGiftListItems = [];
    this.getSelectedProducts().then(() => {
      this.resetSelectedItems(false);
    });
  }

  /**
   * 重新设置选中状态（订单类型、是否管理状态改变后调用）
   * showToast: 是否显示提示
   */
  @action
  resetSelectedItems() {
    for (const cartItem of this.selectedProducts) {
      for (const item of cartItem.itemList) {
        if (this.selectedItems[item.itemSerial] && !this.getItemCanSelect(item)) {
          // 不支持订单类型的产品变为不选中
          delete this.selectedItems[item.itemSerial];
          this.selectedItems = { ...toJS(this.selectedItems) };
        }
      }
    }
  }

  /**
   * 产品列表点击勾选 (选商品)
   */
  @action
  changeSelected(itemSerial, isSelected, cartItemIndex, actId, callback) {
    let selectedItems = { ...this.selectedItems };
    selectedItems[itemSerial] = !isSelected;
    this.selectedItems = selectedItems;
    const timeout = setTimeout(() => {
      this.getDiscountBatch(() => {
        let selectedItems = { ...this.selectedItems };
        selectedItems[itemSerial] = isSelected;
        this.selectedItems = selectedItems;
      }, cartItemIndex);
      const hasSelected = (this.selectedProducts[cartItemIndex].itemList || []).find(
        (item) => this.selectedItems[item.itemSerial]
      );
      if (!hasSelected) {
        delete this.modalObject[actId[cartItemIndex]];
        delete this.giftList[actId[cartItemIndex]];
        delete this.selectedGiftListItems[cartItemIndex];
        this.clearIncPriceShop([cartItemIndex]);
        callback && callback();
      } else {
        this.getIncPriceShopMsg(this.selectedProducts[cartItemIndex].gKey);
        // this.handleSelectedGiftListFan(cartItemIndex, actId); // 反向自动选择赠品
        clearTimeout(timeout);
      }
    }, 0);
  }

  /**
   * 记录所有的活动id  3是赠品
   */
  @action
  selectedActivityItems(gKey = '10086', actId, type) {
    let tableObj = {
      3: 'activityGiftId'
    };
    if (this.allActivityItems[gKey]) {
      this.allActivityItems[gKey][tableObj[type]] = actId;
    } else {
      this.allActivityItems[gKey] = {};
      this.allActivityItems[gKey][tableObj[type]] = actId;
    }
  }

  /**
   * 批量计算活动分组的优惠金额
   */
  getDiscountBatch = flow(function* (callback, cartItemIndex = this.cartIndex) {
    const list = [];
    this.selectedProducts.forEach((cartItem, ind) => {
      const { activityList, itemList } = cartItem;
      const activityInfoReqDtoList = [];
      let indevalue = 0;
      let activityIdValue = [];
      for (const item of itemList) {
        if (this.selectedItems[item.itemSerial]) {
          activityInfoReqDtoList.push(item);
        }
      }
      if (activityList && activityList.length > 0 && this.isJoin) {
        if (activityInfoReqDtoList.length > 0) {
          list.push({
            activityInfoReqDtoList: activityList,
            itemfoReqDtoList: activityInfoReqDtoList,
            distributionRatio: this.distributionRatio,
            discount: this.discount,
            orderType: this.orderType
          });
          for (const item of activityList) {
            if (+item.activityType === 3) {
              activityIdValue.push(item.activityId);
              indevalue = ind;
            }
          }
          // this.handleSelectedGiftListFan(indevalue, Array.isArray(activityIdValue) ? activityIdValue.join(',') : activityIdValue); // 反向自动选择赠品
        }
      } else {
        // if (this.isDiscountMode) {
        if (this.isDiscountMode || Stores.AppMod.isLD || this.memberCard) {
          list.push({
            activityInfoReqDtoList: [],
            itemfoReqDtoList: activityInfoReqDtoList,
            distributionRatio: this.distributionRatio,
            discount: this.discount,
            orderType: this.orderType
          });
        }
      }
    });
    if (list.length == 0) {
      this.activityDiscountInfoListGkey = [];
      return;
    }
    const params = {
      calculateDiscountReqDtoList: list,
      distributionRatio: this.distributionRatio,
      discount: this.discount,
      orderType: this.orderType,
      dgCardno: this.memberCard,
      saleMode: this.globalSaleMode || ''
    };
    if (this.discount) {
      params.discount = this.discount;
    }
    if (this.subActId) {
      params.subActId = this.subActId;
      params.dgStatus = this.origin === 'shop' ? 1 : 2;
    }
    try {
      const { data, resultCode, resultMsg } = yield Serv.getDiscountBatch(params);
      if (+resultCode !== 0) {
        this.handleActivityCommonTip('提示', resultMsg);
        if (resultCode + '' === '123456') {
          return;
        }
      }
      if (data && data.length > 0) {
        this.queryReturnData = data; // 将query返回的分组活动信息包含的多买多赠存到mobox;
        this.totalPureAmount = 0;
        let gKeyData = data;
        gKeyData.forEach((gItem, index) => {
          let gKey = [];
          const activityInfoReqDtoList = get(
            params,
            `calculateDiscountReqDtoList[${index}].activityInfoReqDtoList`
          );
          activityInfoReqDtoList.forEach((item, index) => {
            for (const keyIt in item) {
              if (keyIt == 'activityId') {
                gKey.push(item.activityId);
              }
            }
          });
          gItem.gKey = gKey.join('');
        });

        this.activityDiscountInfoListGkey = gKeyData;

        for (let i = 0; i < data.length; i++) {
          const groupItem = data[i];
          const { activityDiscountInfoList = [], itemDiscountInfoList = [], total = 0 } = groupItem;

          this.totalPureAmount += total;

          const activityIds = activityDiscountInfoList
            ? activityDiscountInfoList.map((item) => {
                return item.activityId;
              })
            : [];

          const { activityList, itemList } = this.selectedProducts[i];
          // 判断两个分组是否相同
          let flag = true;
          if (activityIds.length == activityList.length) {
            for (let j = 0; j < activityList.length; j++) {
              if (!activityIds.includes(activityList[j].activityId)) {
                flag = false;
                break;
              }
            }
          } else {
            flag = false;
          }

          // 找到相同分组
          if (this.isDiscountMode || flag) {
            // 设置活动项优惠
            for (const item of activityDiscountInfoList) {
              const { activityId } = item;
              for (let j = 0; j < activityList.length; j++) {
                if (activityList[j].activityId == activityId) {
                  this.selectedProducts[i].activityList[j] = {
                    ...this.selectedProducts[i].activityList[j],
                    ...item
                  };
                  break;
                }
              }
            }
            // 设置产品项优惠
            for (const item of itemDiscountInfoList) {
              const { itemSerial, discount, discountBv, price, bv, promotionBv } = item;
              for (let j = 0; j < itemList.length; j++) {
                if (itemList[j].itemSerial == itemSerial) {
                  this.selectedProducts[i].itemList[j] = {
                    ...this.selectedProducts[i].itemList[j],
                    ...{
                      discount: discount,
                      discountBv: discountBv,
                      lessBv: bv,
                      lessPrice: price,
                      promotionBv: promotionBv
                    }
                  };
                  continue;
                }
              }
            }
          }
        }
      }

      // setTimeout(()=>{
      let infoList = data;
      let twoArr = Array.isArray(infoList) && infoList.map((m) => m.itemDiscountInfoList).flat(1);
      let twoArrKeys = twoArr.map((m) => m.itemSerial) || [];
      console.log(twoArr, '--->twoArr');
      const { activityList, itemList } = this.selectedProducts[cartItemIndex];
      itemList.forEach((fi) => {
        if (twoArrKeys.includes(fi.itemSerial)) {
          let { discountBv, discount } = twoArr.find((f) => f.itemSerial === fi.itemSerial) || {};
          fi.discount = discount;
          fi.discountBv = discountBv;
        }
      });

      if (!this.selectedGiftListItems.length) {
        this.selectedProducts.forEach((selectProductGroup, index) => {
          console.log('1112222', selectProductGroup);
          // 计算当前分组中的满赠活动是否达到了满赠条件
          const { activityList = [] } = selectProductGroup || {};
          const activityKey = getActivityListKey(activityList);
          const currentActivityDiscountInfoList = data.find((queryData) => {
            const activityDiscountInfoList = queryData.activityDiscountInfoList || [];
            const activityDiscountKey = getActivityListKey(activityDiscountInfoList);
            return activityKey === activityDiscountKey;
          });

          if (!isEmpty(currentActivityDiscountInfoList)) {
            const activityDiscountInfoList =
              currentActivityDiscountInfoList.activityDiscountInfoList || [];
            const hasFullGiftAchieveIds = activityDiscountInfoList
              .filter((f) => f.activityType == 3)
              .map((item) => item.activityId);
            if (hasFullGiftAchieveIds.length) {
              this.handleSelectedGiftListFan(index, hasFullGiftAchieveIds.join(','));
            }
          }
        });
      } else {
        const cartItem = this.selectedProducts[cartItemIndex];

        let activityIdValue =
          cartItem.activityList &&
          cartItem.activityList.filter((f) => f.activityType == 3).map((m) => m.activityId);
        this.handleSelectedGiftListFan(
          cartItemIndex,
          Array.isArray(activityIdValue) ? activityIdValue.join(',') : activityIdValue
        ); // 反向自动选择赠品
      }

      // this.queryJt(cartItemIndex)
      // },100)
    } catch (error) {
      callback && callback();
    }
  });

  /**
   * 切换分组的促销
   *
   * @param {object} activityItem 当前取消的活动信息
   * @param {object} sectionActivityList 当前分组的活动信息-变化前的
   * @param {number} sectionIndex  当前分组的索引
   */
  @action
  switchSectionActivity = (activityItem, sectionActivityList, sectionIndex) => {
    //计算变化之后的新的activityList
    const oldActivityList = sectionActivityList;
    const newActivityList = oldActivityList.filter(
      (item) => item.activityId !== activityItem.activityId
    );

    // 查找要切换的活动组是否存在
    let cartIndex = -1;
    for (let i = 0; i < this.selectedProducts.length; i++) {
      const { groupLabel, activityList = [] } = this.selectedProducts[i];
      const activityIds = activityList
        ? activityList.map((item) => {
            return item.activityId;
          })
        : [];
      if (`${groupLabel}` == '6') {
        let flag = true;
        if (activityIds.length == newActivityList.length) {
          for (let j = 0; j < newActivityList.length; j++) {
            if (!activityIds.includes(newActivityList[j].activityId)) {
              flag = false;
              break;
            }
          }
        } else {
          flag = false;
        }

        if (flag) {
          cartIndex = i;
          break;
        }
      }
    }

    let incPriceIndex = sectionIndex; // 记录获取加价购组
    if (cartIndex != sectionIndex) {
      let { selectedProducts } = this;
      const items = selectedProducts[sectionIndex].itemList;

      // 如果商品没有选中活动，则重置商品的优惠金额和BV
      if (!newActivityList || newActivityList.length == 0) {
        items[0].discount = 0;
        items[0].discountBv = 0;
      }

      //当前分组不存在，组成新的分组， 放到数组头位
      if (cartIndex == -1) {
        incPriceIndex = 0;
        selectedProducts.unshift({
          activityList: newActivityList,
          groupLabel: 6,
          groupLabelName: '普通',
          itemList: items,
          mustBuyItemMap:
            selectedProducts[sectionIndex] && selectedProducts[sectionIndex].mustBuyItemMap
        });
        // 添加了新分组，旧的索引要+1
        sectionIndex += 1;
      } else {
        //分组已存在，把变化分组的商品插入到对应的分组里
        incPriceIndex = cartIndex;
        selectedProducts[cartIndex].itemList.unshift(...items);
      }

      // 如果删除的组在加价购组前面, 加价购组索引需要-1
      if (incPriceIndex > sectionIndex) {
        incPriceIndex -= 1;
      }
      // 删除当前变化的分组
      selectedProducts.splice(sectionIndex, 1);
      this.selectedProducts = this.addActivityProductsKeys(toJS(selectedProducts));
      this.selectedGiftListItems = [];
      if (this.isVipRebuy) {
        this.orderType = '10';
        this.distributionRatio = '1';
      }

      if (!this.isVipRebuy && this.orderType == '10') {
        this.orderType = '1';
        if (this.isDiscountMode && !this.isShopMasterMode) {
          this.discount = '1';
        } else {
          this.distributionRatio = '1';
        }
        this.getselectedProducts();
      }
      this.getIncPriceShopMsg(this.selectedProducts[incPriceIndex].gKey);
      this.getDiscountBatch();
    }
  };

  /**
   * 给每个分组增加key
   */
  @action
  addActivityProductsKeys(selectedProducts) {
    // let list = []
    // let actGKey = ''

    selectedProducts.forEach((item, index) => {
      let arrActKeys = [];
      const { activityList = [] } = item;
      if (activityList.length > 0) {
        activityList.forEach((it, idx) => {
          // const {subActivityId, subCardCode} = it;
          // this.subActivityId = subActivityId;
          // this.subCardCode = subCardCode;
          arrActKeys.push(it.activityId);
        });
        item.gKey = arrActKeys.join('');
      }
    });

    return selectedProducts;
  }

  /**
   * 切换促销
   */
  @action
  switchActivity(list) {
    let cartIndex = -1;
    let activityIdList = [];
    list.forEach((itemValue) => {
      if (+itemValue.activityType === 3) {
        activityIdList.push(itemValue.activityId);
      }
    });
    this.selectActivityId = activityIdList; // 已选满赠活动的数组集合赋值到mobx
    for (let i = 0; i < this.selectedProducts.length; i++) {
      const { groupLabel, activityList = [] } = this.selectedProducts[i];
      const activityIds = activityList
        ? activityList.map((item) => {
            return item.activityId;
          })
        : [];
      if (`${groupLabel}` == '6') {
        let flag = true;
        if (activityIds.length == list.length) {
          for (let j = 0; j < list.length; j++) {
            if (!activityIds.includes(list[j].activityId)) {
              flag = false;
              break;
            }
          }
        } else {
          flag = false;
        }

        if (flag) {
          cartIndex = i;
          break;
        }
      }
    }

    let [cartItemIndex, itemIndex] = this.switchIndexs;
    let incPriceIndex = cartItemIndex; // 记录获取加价购组
    if (cartIndex != cartItemIndex) {
      let { selectedProducts } = this;
      const items = selectedProducts[cartItemIndex].itemList.splice(itemIndex, 1);

      if (cartIndex == -1) {
        // 新的分组, 放到数组头位
        incPriceIndex = 0;
        selectedProducts.unshift({
          activityList: list,
          groupLabel: 6,
          groupLabelName: '普通',
          itemList: items,
          mustBuyItemMap:
            selectedProducts[cartItemIndex] && selectedProducts[cartItemIndex].mustBuyItemMap
        });
        // 添加了新分组，旧的索引要+1
        cartItemIndex += 1;
      } else {
        // 没有新分组,
        incPriceIndex = cartIndex;
        selectedProducts[cartIndex].itemList.unshift(items[0]);
      }

      if (selectedProducts[cartItemIndex].itemList.length == 0) {
        // 如果删除的组在加价购组前面, 加价购组索引需要-1
        if (incPriceIndex > cartItemIndex) {
          incPriceIndex -= 1;
        }
        selectedProducts.splice(cartItemIndex, 1);
      }
      this.selectedGiftListItems = [];
      this.selectedProducts = this.addActivityProductsKeys(toJS(this.selectedProducts));
      this.selectedProducts.forEach((products, index) => {
        products.itemList.forEach((_item, _index) => {
          const { isMustBuy, limitBuyNum } = this.findProductInValidActivity(
            this.selectedProducts[index],
            _item.itemSerial
          );
          if (isMustBuy && _item.itemNum < limitBuyNum) {
            _item.itemNum = limitBuyNum;
            this.changeItemNum(_item.itemNum, index, _index, _item.itemSerial, 0, false, true);
          }
        });
      });
      if (this.isVipRebuy) {
        this.orderType = '10';
        this.distributionRatio = '1';
      }
      if (!this.isVipRebuy && this.orderType == '10') {
        this.orderType = '1';
        if (this.isDiscountMode && !this.isShopMasterMode) {
          this.discount = '1';
        } else {
          this.distributionRatio = '1';
        }
        this.getSelectedProducts();
      }
      this.getIncPriceShopMsg(this.selectedProducts[incPriceIndex].gKey);
      this.getDiscountBatch();
    }
  }

  /**
   * 改变已选产品列表商品数量
   */
  @action
  changeItemNum(number, cartIndex, index, itemSerial, minNumber, ignore0 = false, noCheck = false) {
    let selectedProducts = JSON.parse(JSON.stringify(this.selectedProducts));
    selectedProducts[cartIndex].itemList[index].itemNum = number;
    if (number == 0 || (minNumber && number < minNumber)) {
      selectedProducts[cartIndex].itemList.splice(index, 1);
      if (selectedProducts[cartIndex].itemList.length == 0) {
        selectedProducts.splice(cartIndex, 1);
      }
    }
    console.log(toJS(selectedProducts), 'selectedProducts is what?');

    // let skuCheckLists = JSON.parse(JSON.stringify(this.skuCheckLists));
    // let isSku = false
    // console.log(itemSerial,number,'w s ===',skuCheckLists);
    // for (let key in skuCheckLists) {
    //   skuCheckLists[key].length > 0 && skuCheckLists[key].map(el=>{
    //     if (el.itemSerial == itemSerial) {
    //       el.num = number
    //       el.itemNum = number
    //       isSku = true
    //     }
    //   })
    // }
    // if (isSku) {
    //   this.skuCheckLists = skuCheckLists
    //   console.log('his.skuCheckLists========',toJS(this.skuCheckLists));
    //   // return
    // }
    this.selectedProducts = selectedProducts;
    // 修改选购产品列表数量
    let obj = toJS(Object.assign({}, this.productMsgMap));
    let { fatherItemSerial, itemNum } = obj[itemSerial];
    obj[itemSerial].itemNum = number;
    let fatherItemNum = obj[fatherItemSerial] && obj[fatherItemSerial].itemNum; // 父产品的数量
    if (fatherItemNum) {
      obj[fatherItemSerial].itemNum = fatherItemNum - itemNum + number;
    }
    if (obj[itemSerial].itemNum <= 0) {
      obj[itemSerial].selected = false;
    } else {
      obj[itemSerial].selected = true;
    }
    this.productMsgMap = obj;
    this.changeDisRatio();
    // 如果数量增减变化在延迟时间之内，并且是重复点击同一个商品，取消之前的回调，减少频繁回调请求接口
    if (this.timer && itemSerial === this.currentChangeId) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    // 记录正在计时的商品
    this.currentChangeId = itemSerial;

    this.timer = setTimeout(() => {
      if ((!number || number <= 0 || !Number.isInteger(number) || noCheck) && !ignore0) {
        return;
      }
      this.getDiscountBatch(null, cartIndex);
      this.getIncPriceShopMsg(this.selectedProducts[cartIndex].gKey);
    }, 1000);

    // 如果当前不是vip，重置订单类型和配货比例
    if (!this.isVipRebuy && this.orderType == '10') {
      this.orderType = '1';
      this.distributionRatio = '1';
      this.getSelectedProducts();
    }
  }

  /**
   * 加减加价购商品
   */
  @action
  changeCountIncPrice(cartItemIndex, index, count) {
    let selectedProducts = [...this.selectedProducts];
    const { maxIncPriceNum } = selectedProducts[cartItemIndex].incPriceShop;
    const addCount = count - selectedProducts[cartItemIndex].incPriceShop.items[index].itemNum;
    if (addCount + this.incPriceTotal[cartItemIndex].count > maxIncPriceNum) {
      Toast.info('数量超过限制', 3, null, false);
      return;
    }
    selectedProducts[cartItemIndex].incPriceShop.items[index].itemNum = +count;
    this.selectedProducts = selectedProducts;
  }

  /**
   * 勾选加价购商品
   */
  @action
  switchIncPriceSelect(cartItemIndex, index, isSelected) {
    let selectedProducts = [...this.selectedProducts];
    const { items, maxIncPriceNum } = selectedProducts[cartItemIndex].incPriceShop;
    if (
      isSelected &&
      items[index].itemNum + this.incPriceTotal[cartItemIndex].count > maxIncPriceNum
    ) {
      Toast.info(`加价购可选上限为${maxIncPriceNum}`, 3, null, false);
      return;
    }
    selectedProducts[cartItemIndex].incPriceShop.items[index].isSelected = isSelected;
    this.selectedProducts = selectedProducts;
  }

  /**
   * 加价购合计对象，包含‘总数量’、‘金额’...
   */
  @computed
  get incPriceTotal() {
    let total = [];
    this.selectedProducts.forEach((cartItem, index) => {
      total.push({ count: 0, money: 0 });
      if (cartItem.itemList.find((item) => this.selectedItems[item.itemSerial])) {
        let items = get(cartItem, 'incPriceShop.items', []);
        if (items.length > 0) {
          items.forEach((item) => {
            if (item.isSelected) {
              total[index].count += item.itemNum;
              // 指定金额加购
              if (cartItem.incPriceShop.incPriceType == 1) {
                total[index].money += item.itemNum * cartItem.incPriceShop.incPriceMoney;
              } else {
                // 指定折扣加购
                let list = [0, ...cartItem.incPriceShop.items];
                total[index].money += list.reduce((pre, next) =>
                  !next.isSelected
                    ? pre
                    : pre + next.salePrice * next.itemNum * cartItem.incPriceShop.incPriceMoney
                );
                total[index].money = +(total[index].money / 100).toFixed(2);
              }
            }
          });
        }
      }
    });
    return total;
  }

  @action
  changeSelectedAll() {
    // this.selectedProducts.length > 0 &&
    // this.selectedProducts.map((item, index) => {
    //   let ids = [];
    //   item.activityList && item.activityList.map((inerItem) => {
    //       inerItem.activityType * 1 === 3 && ids.push(inerItem.activityId);
    //   });
    //   this.handleSelectedGiftListFan(index, ids.join(','));
    // });
    if (this.isSelectedAll) {
      // 取消全选时，将赠品置空
      this.selectedGiftListItems = [];
    }
    let selectedItems = { ...this.selectedItems };
    this.selectedProducts.forEach((cartItem, index) => {
      for (const item of cartItem.itemList) {
        if (!this.isSelectedAll) {
          // 没有全选
          if (this.getItemCanSelect(item)) {
            selectedItems[item.itemSerial] = true;
          }
        } else {
          selectedItems[item.itemSerial] = false;
        }
      }
    });
    this.selectedItems = selectedItems;
    if (this.selectedProducts) {
      for (let i = 0; i < this.selectedProducts.length; i++) {
        if (this.isSelectedAll) {
          this.getIncPriceShopMsg(this.selectedProducts[i].gKey);
        }
      }
    }

    this.getDiscountBatch(() => {
      this.changeSelectedAll();
    });
  }

  /**
   * 是否全选
   */
  @computed
  get isSelectedAll() {
    if (!this.selectedProducts || this.selectedProducts.length == 0) {
      return false;
    }

    let flag = false; // 防止一项都未选会出现全选的情况
    for (const cartItem of this.selectedProducts) {
      for (const item of cartItem.itemList) {
        if (this.getItemCanSelect(item)) {
          if (this.selectedItems[item.itemSerial]) {
            flag = true;
          } else {
            return false;
          }
        }
      }
    }
    return flag;
  }

  /**
   * 去凑单，获取活动产品列表
   */
  getActivityProductList = flow(function* (activityIdList) {
    const params = {
      activityIdList,
      orderType: this.orderType,
      discount: this.discount,
      distributionRatio: this.distributionRatio,
      discount: this.discount,
      dgCardno: this.memberCard
    };
    try {
      const { data, resultCode, resultMsg } = yield Serv.getActivityProductList(params);
      if (resultCode != 0) {
        Toast.fail(resultMsg, 2, null, false);
        return;
      }

      if (Array.isArray(data)) {
        set(this.menuChildMap, { _default: data });
        data.forEach((_val) => {
          if (!this.productMsgMap[_val.itemSerial]) {
            this.productMsgMap[_val.itemSerial] = {
              itemNum: 0,
              selected: false,
              ..._val
            };
          }
        });
      }
    } catch (error) {}
  });

  /**
   * 查看或收起套餐内容
   */
  @action
  showMoreCombination(cartIndex, index) {
    const { selectedProducts } = this;
    if (selectedProducts[cartIndex].itemList[index].hideMoreCombination) {
      selectedProducts[cartIndex].itemList[index].hideMoreCombination = false;
    } else {
      selectedProducts[cartIndex].itemList[index].hideMoreCombination = true;
    }
    this.selectedProducts = selectedProducts;
  }

  /**
   * 新零售 获取折扣信息
   */
  getDiscountList = flow(function* (memberCard) {
    try {
      let params = {
        orderType: 1,
        saleMode: this.globalSaleMode || ''
      };
      if (Stores.AppMod.userInfo.userName) {
        params.shopCode = Stores.AppMod.userInfo.userName;
      }
      if (memberCard) {
        params.dgCardCode = memberCard;
        params.dgStatus = 1;
      }
      let obj = {};
      let defaultItem = {
        label: '全价',
        orderMinAmount: 0,
        value: 1
      };
      let handleDiscountMap = (data) => {
        let distMap = [];
        if (data && data.length > 0) {
          // 按从小到大排序
          for (let i = 0; i < data.length - 1; i++) {
            for (let j = 0; j < data.length - 1 - i; j++) {
              if (+data[j].orderDiscount > +data[j + 1].orderDiscount) {
                [data[j], data[j + 1]] = [data[j + 1], data[j]];
              }
            }
          }

          distMap = data.map((item) => {
            const { orderDiscount, orderDiscountExplain, orderMinAmount } = item;

            return {
              value: orderDiscount,
              label: `${orderDiscountExplain}折`,
              orderMinAmount
            };
          });
        }
        return distMap;
      };
      console.log('enter discount list', params);
      const { data } = yield Serv.getDiscountList(params);
      if (data.dataType == 1) {
        obj['1'] = [...handleDiscountMap(data.lstDiscount), defaultItem];
      }

      let params_2 = {
        orderType: 2,
        saleMode: this.globalSaleMode || ''
      };
      if (Stores.AppMod.userInfo.userName) {
        params_2.shopCode = Stores.AppMod.userInfo.userName;
      }
      if (memberCard) {
        params_2.dgCardCode = memberCard;
        params_2.dgStatus = 1;
      }
      const { data: data2 } = yield Serv.getDiscountList(params_2);
      if (data2.dataType == 1) {
        obj['2'] = [...handleDiscountMap(data2.lstDiscount), defaultItem];
      }
      this.discountList = obj;
      Object.keys(obj).length > 0 && this.handleDiscount();
    } catch (error) {}
  });

  /**
   * 处理折扣比例，根据接口返回设置
   */
  @action
  handleDiscount() {
    if (!this.discount) {
      console.log(this.isDiscountMod, 'this.isDiscountModthis.isDiscountMod');
      if (this.isDiscountMode) {
        this.discount = this.discountList['1'][0].value;
        this.distributionRatio = 1;
        reaction(
          () => this.discount,
          (data) => {
            this.menuId &&
              (this.isQualification
                ? this.getZiGeProductList(this.menuId, this.idObjectParam)
                : this.getProductList(this.menuId));
          }
        );
        reaction(
          () => this.orderType,
          (data) => {
            this.menuId &&
              (this.isQualification
                ? this.getZiGeProductList(this.menuId, this.idObjectParam)
                : this.getProductList(this.menuId));
          }
        );
        this.isQualification
          ? this.getZiGeProductList(this.menuId, this.idObjectParam)
          : this.getProductList(this.menuId);
      } else {
        this.distributionRatio = '';
      }
    }
  }

  // 订单应付满减金额/bv
  @computed
  get orderMinAmount() {
    let text = '';
    this.orderTypeList.forEach((item) => {
      if (item.value == this.orderType && this.discountList[item.value]) {
        this.discountList[item.value].forEach((subItem) => {
          if (this.discount == subItem.value) {
            text = subItem.orderMinAmount;
          }
        });
      }
    });
    return text;
  }
  // 最小金额提示
  @computed
  get minNumberTip() {
    let text = '';
    if (this.orderMinAmount > 0) {
      if (this.orderType * 1 == 1) {
        text = `订单应付满${Util.formatMoney({ value: this.orderMinAmount, showPrefix: false, showCurrencyName: true, precision: 0 })}可用`;
      } else {
        text = `订单应付满${this.orderMinAmount}BV可用`;
      }
    }

    return text;
  }

  getDistriBution = flow(function* (memberCard) {
    try {
      let params_1 = {
        shopCode: Stores.AppMod.userInfo.userName, // 店铺编号字段居然是userName，对后端无语了😒
        orderType: 1,
        saleMode: this.globalSaleMode || ''
      };
      if (memberCard) {
        params_1.dgCardCode = memberCard;
        params_1.dgStatus = 1;
      }
      let { data } = yield Serv.getDistriBution(params_1);

      let obj = {};
      let defaultItem = {
        label: '未选择',
        orderMinAmount: 0,
        value: '-1'
      };
      if (Stores.AppMod.isLY) {
        data = data.filter((item) => item.orderProperty === '1');
      }

      let handleDistriBution = (data) => {
        let distMap = [];
        if (data && data.length > 0) {
          // 按从小到大排序
          // for (let i = 0; i < data.length - 1; i++) {
          //   for (let j = 0; j < data.length - 1 - i; j++) {
          //     if (+data[j].orderProperty > +data[j + 1].orderProperty) {
          //       [data[j], data[j + 1]] = [data[j + 1], data[j]];
          //     }
          //   }
          // }

          distMap = data.map((item) => {
            const { orderProperty, orderPropertyName, orderMinAmount, aliasName } = item;
            console.log(data, 'data============');
            return {
              value: orderProperty,
              // label: `${orderPropertyName} 配货`,
              label: `${aliasName}`,
              orderMinAmount
            };
          });
        }
        return distMap;
      };
      obj['1'] = [...handleDistriBution(data)];
      let params_2 = {
        shopCode: Stores.AppMod.userInfo.userName,
        orderType: 2,
        saleMode: this.globalSaleMode || ''
      };
      if (memberCard) {
        params_2.dgCardCode = memberCard;
        params_2.dgStatus = 1;
      }
      let { data: data2 } = yield Serv.getDistriBution(params_2);
      if (Stores.AppMod.isLY) {
        data2 = data2.filter((item) => item.orderProperty === '1');
      }
      obj['2'] = [...handleDistriBution(data2)];
      this.storeDistributionList = obj;
      this.oldStoreDistributionList = obj;

      console.log('------storeDistributionList--', this.storeDistributionList);
      this.handleDistributionRatio();
      // let list = [];
      // if (data && data.length > 0) {
      //   // 按从小到大排序
      //   for (let i = 0; i < data.length - 1; i++) {
      //     for (let j = 0; j < data.length - 1 - i; j++) {
      //       if (+data[j].orderProperty > +data[j + 1].orderProperty) {
      //         [data[j], data[j + 1]] = [data[j + 1], data[j]];
      //       }
      //     }
      //   }

      //   list = data.map(item => {
      //     const { orderProperty, orderPropertyName, orderMinAmount } = item;

      //     return { value: orderProperty, label: `${orderPropertyName} 配货`, orderMinAmount };
      //   });
      // }

      // this.storeDistributionList = list || [];
      // this.handleDistributionRatio();
    } catch (error) {}
  });

  /**
   * 获取用户支持的配货比例，存入userInfo
   */
  // getUserdistriBution = flow(function*() {
  //   if (!this.token) {
  //     return;
  //   }
  //   try {
  //     const { data } = yield Serv.getUserdistriBution({orderType: 1});
  //     // let distributionRatioList = [];
  //     let obj = {};
  //     let defaultItem = {
  //       label: '未选择',
  //       orderMinAmount: 0,
  //       value: '-1',
  //     };
  //     let handleDistriBution = (data) => {
  //       let distMap = [];
  //       if (data && data.length > 0) {
  //         // 按从小到大排序
  //         for (let i = 0; i < data.length - 1; i++) {
  //           for (let j = 0; j < data.length - 1 - i; j++) {
  //             if (+data[j].orderProperty > +data[j + 1].orderProperty) {
  //               [data[j], data[j + 1]] = [data[j + 1], data[j]];
  //             }
  //           }
  //         }

  //         distMap = data.map(item => {
  //           const { orderProperty, orderPropertyName, orderMinAmount } = item;

  //           return { value: orderProperty, label: `${orderPropertyName} 配货`, orderMinAmount };
  //         });
  //       }
  //       return distMap;
  //     };
  //     obj['1'] = [defaultItem, ...handleDistriBution(data)];
  //     const { data: data2 } = yield Serv.getUserdistriBution({orderType: 2});
  //     obj['2']  = [defaultItem, ...handleDistriBution(data2)];

  //     this.userInfo = { ...this.userInfo, distributionRatioList: obj };
  //     Util.setLocalCache(Config.localStorageKeys.member_userInfo, this.userInfo);
  //   } catch (error) {}
  // });

  /**
   * 是否有1：2配货比例的弹窗
   *
   */
  getDistributionTip = flow(function* (params) {
    if (this.globalSaleMode) {
      params.saleMode = this.globalSaleMode || '';
    }
    try {
      const result = yield Serv.getDistributionTip(params);
      if (result && result.resultCode == '0') {
        return result.data == 1;
      }
      return false;
    } catch (error) {
      return false;
    }
  });

  // 多规格商品
  getMoreMultiList = flow(function* (id) {
    try {
      const { data } = yield Serv.getMoreMultiList(id);
      if (data && data.subItem) {
        let _moreSpecificationsData = data.subItem || [];
        const _selectedList = _.cloneDeep(toJS(this.selectedList)) || [];
        !!_selectedList.length &&
          _selectedList.map((el) => {
            _moreSpecificationsData.forEach((ele) => {
              if (el.code == ele.code) {
                ele.selected = true;
                ele.count = el.count;
                ele.itemNum = el.count;
              }
            });
          });
        this.moreSpecificationsData = _moreSpecificationsData;

        let obj = Object.assign({}, this.productMsgMap);
        !!_moreSpecificationsData.length &&
          _moreSpecificationsData.forEach((_val) => {
            if (!obj[_val.itemSerial]) {
              obj[_val.itemSerial] = {
                itemNum: 0,
                data: _val,
                selected: false
              };
            }
          });
        this.productMsgMap = obj;
      }
      return data;
    } catch (e) {}
  });

  /**
   *校验是否是有库存
   *
   * @memberof QuickBuyMod
   */
  checkStoveFull = flow(function* (params) {
    try {
      const { data } = yield Serv.checkStoveFull(params);
      if (!data) {
        Toast.info('商品数量库存不足！');
      }
    } catch (error) {
      return false;
    }
  });

  // 检查商品是否必购
  findProductInValidActivity(cartItem, productId) {
    const { activityList = [], mustBuyItemMap = {} } = cartItem || {};
    if (!activityList || !activityList.length || !mustBuyItemMap) {
      return {};
    }
    // 遍历mustBuyItemMap的所有活动
    for (const [activityId, items] of Object.entries(mustBuyItemMap)) {
      // 检查活动是否在activityList中
      if (activityList.some((activity) => activity.activityId === activityId)) {
        // 检查当前活动是否包含目标商品
        const matchingItem = items.find((item) => item.itemId === productId);
        if (matchingItem) {
          return matchingItem;
        }
      }
    }
    return {};
  }

  @action
  clearData() {
    this.orderType = '1';
    this.distributionRatio = '';
    this.discount = '';
    this.discountList = [];
    this.menuList = [];
    this.menuChildMap = { _default: [] };
    this.productMsgMap = {};
    this.menuId = '';
    this.activeKeys = ['', '', ''];
    this.menuTitle = '';
    this.detailId = '';
    this.keyword = '';
    this.showDetail = false;
    this.selectedProducts = [];
    this.tabIndex = 0;
    this.selectedItems = {};
    this.isJoin = true;
    this.switchIndexs = [];
    this.isScrape = false;
    this.storeDistributionList = null;
    this.oldStoreDistributionList = null;
    this.oldAcrossDisRatioItemId = '';
    // this.acrossDisRatioItemId = '';
    this.isQualification = false;
    this.skuCheckLists = {};
    this.fromPage = '';
    this.hadAccumulateAmount = null;
    this.currentCardTypeName = '';
    this.currentCardType = null;
    this.selectedId = -1;
    this.selectedGiftListItems = [];
  }
  @action
  saleModeClearData() {
    this.selectedProducts = [];
    this.productMsgMap = {};
  }
  /**
   * 清除加价购数据
   */
  @action
  clearIncPriceShop(indexs) {
    for (let index of indexs) {
      this.selectedProducts[index].incPriceShop = null;
    }
  }

  /**
   * 获取卡级别
   */
  getCardList = flow(function* () {
    try {
      const { resultCode, data } = yield Serv.getCardList();
      if (resultCode == 0) {
        runInAction(() => {
          this.cardList = (data.list || []).filter((item) => item.type <= 6);
          let currentData = (data.list || []).find((item) => item.type === data.cardType);
          if (currentData) {
            this.currentCardTypeName = currentData.name;
          }
          this.currentCardType = data.cardType;
          this.hadAccumulateAmount = data.hadAccumulateAmount;
        });
      }
    } catch (error) {}
  });
  /**
   * 获取客的卡级别
   */
  getDgCardList = flow(function* (params) {
    try {
      const { resultCode, data } = yield Serv.getDgCardList(params);
      if (resultCode == 0) {
        runInAction(() => {
          this.currentCardTypeName = data.cardTypeName;
          this.currentCardType = data.cardType;
          this.hadAccumulateAmount = data.hadAccumulateAmount;
        });
      }
    } catch (error) {
      console.log('err', error);
    }
  });

  /**
   * 获取应用位数据
   */
  getApplication = flow(function* ({ memberCard, origin }) {
    try {
      const { resultCode, data } = yield Serv.getApplication({ memberCard });
      if (resultCode == 0) {
        const xkcActivityList = [];
        // 已和业务确认，享考察资格购后面只配置消费活动，可以不用考虑销售专区的情况了
        this.application = (data || []).filter((item) => {
          // 特殊控制 ldDiscountTag 0 无 1 LD享折扣 2 享考察
          if (item.ldDiscountTag === 2) {
            // 享考察 只在 国际站 店长代客场景 下显示
            if (memberCard && origin === 'shop' && Stores.AppMod.isInternationalized) {
              item.isXkcActivity = true;
              item.dirIconPath = item.imgUrl;
              xkcActivityList.push(item);
            }
            return false;
          }
          return true;
        });
        this.xkcActivityList = xkcActivityList;
      }
    } catch (error) {
      console.log('error>>>>getApplication', error);
    }
  });

  // 获取用户信息
  getMemberInfo = flow(function* (params) {
    if (!params.cardCode) return;
    try {
      const { data } = yield Serv.getMemberInfo(params);
      return data;
    } catch (error) {
      console.log(error);
    }
  });

  getCouponList = flow(function* (params) {
    try {
      const { data, resultCode } = yield Serv.getCouponList(params);
      if (resultCode == 0 && data && data.list && data.list.length > 0) {
        return data.list[0];
      }
      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  });

  validateSwitchClose = flow(function* (params) {
    try {
      return yield Serv.validateSwitchClose(params);
    } catch (e) {
      console.log('error', e);
    }
  });
}
const quickBuyMod = new QuickBuyMod();
export default quickBuyMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/QuickBuy/QuickBuyMod.js